var reactApp =
webpackJsonpreactApp([0],{

/***/ "/ZeP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Button = __webpack_require__("Cpum");

var _Button2 = _interopRequireDefault(_Button);

var _styles = __webpack_require__("6mvI");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-line


var QualMediaBlockContainer = function (_Component) {
	_inherits(QualMediaBlockContainer, _Component);

	function QualMediaBlockContainer(props) {
		_classCallCheck(this, QualMediaBlockContainer);

		var _this = _possibleConstructorReturn(this, (QualMediaBlockContainer.__proto__ || Object.getPrototypeOf(QualMediaBlockContainer)).call(this, props));

		_this.displayName = 'QualMediaBlockContainer';

		_this.openMediaGallery = _this.openMediaGallery.bind(_this);
		return _this;
	}

	_createClass(QualMediaBlockContainer, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'qual-media-block-wrapper' },
				_react2.default.createElement(_Button2.default, {
					styleName: 'btnCancel',
					onClick: this.openMediaGallery,
					buttonStyle: _Button2.default.BUTTON_STYLE.CENTERED_CONTENT,
					text: this.props.mediaButtonLabelStr || 'Media',
					small: true
				})
			);
		}
	}, {
		key: 'openMediaGallery',
		value: function openMediaGallery() {}
	}]);

	return QualMediaBlockContainer;
}(_react.Component);

QualMediaBlockContainer.defaultProps = {};

exports.default = (0, _reactCssModules2.default)(QualMediaBlockContainer, _styles2.default);

/***/ }),

/***/ "1HbX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _styles = __webpack_require__("44h3");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBoxComponent = function SearchBoxComponent(_ref) {
  var value = _ref.value,
      onValueChange = _ref.onValueChange,
      onKeyUp = _ref.onKeyUp,
      onApply = _ref.onApply,
      iconClass = _ref.iconClass,
      searchPh = _ref.searchPh;

  return _react2.default.createElement(
    'div',
    { styleName: 'searchbox-wrapper' },
    _react2.default.createElement('input', {
      placeholder: searchPh,
      type: 'text',
      value: value,
      onChange: onValueChange,
      onKeyUp: onKeyUp
    }),
    _react2.default.createElement('span', {
      styleName: 'iconSearch',
      className: iconClass,
      onClick: onApply
    })
  );
};

SearchBoxComponent.defaultProps = {
  value: '',
  onValueChange: function onValueChange() {},
  onKeyUp: function onKeyUp() {},
  onApply: function onApply() {},
  iconClass: 'fa fa-search',
  searchPh: ''
};

exports.default = (0, _reactCssModules2.default)(SearchBoxComponent, _extends({}, _styles2.default), { allowMultiple: true });

/***/ }),

/***/ "3bmd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3nYV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultState = {
  loading: false,
  timeRange: {},
  settings: {},
  metadata: {},
  derivedQuestions: {},
  exportList: {},
  analyze: {},
  filters: {},
  subpopulations: {},
  weightings: {}
};

var TEST_ACTION = 'TA/ACTIONS/TEST_ACTION';

var testAction = exports.testAction = function testAction() {
  return { type: TEST_ACTION, data: 'test' };
};

var reportReducer = function reportReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];

  switch (action.type) {
    case TEST_ACTION:
      return state;
    default:
      return state;
  }
};

exports.default = reportReducer;

/***/ }),

/***/ "44h3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"searchbox-wrapper":"styles__searchbox-wrapper___3C9vi","iconSearch":"styles__iconSearch___2mMKs"};

/***/ }),

/***/ "4hlX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQualMedia = exports.onDataLoadedJquery = exports.changeTableSort = exports.loadData = exports.removeTable = exports.addTable = exports.tableDataLoadEnd = exports.tableDataLoadStart = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__("jsux");

var _constants2 = _interopRequireDefault(_constants);

var _selectors = __webpack_require__("Oe4J");

var SELECTORS = _interopRequireWildcard(_selectors);

var _api = __webpack_require__("9FGC");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = _constants2.default.initialState,
    defaultTableState = _constants2.default.defaultTableState,
    TABLE_ACTIONS_ENUM = _constants2.default.TABLE_ACTIONS_ENUM,
    SORT_DIRECTIONS_ENUM = _constants2.default.SORT_DIRECTIONS_ENUM,
    ACTION_NAMES = _constants2.default.ACTION_NAMES;

/** ACTIONS **/

var updateTableProperties = function updateTableProperties(properties) {
  return {
    type: ACTION_NAMES.TABLE_UPDATE_SCALAR_PROPERTIES,
    properties: _extends({}, properties)
  };
};

var tableDataLoadStart = exports.tableDataLoadStart = function tableDataLoadStart(questionId) {
  return {
    type: ACTION_NAMES.TABLE_DATA_LOAD_START,
    questionId: questionId
  };
};

var tableDataLoadSuccess = function tableDataLoadSuccess(data) {
  return _extends({
    type: ACTION_NAMES.TABLE_DATA_LOAD_SUCCESS
  }, data);
};

var tableDataLoadEnd = exports.tableDataLoadEnd = function tableDataLoadEnd(questionId) {
  return {
    type: ACTION_NAMES.TABLE_DATA_LOAD_END,
    questionId: questionId
  };
};

var addTable = exports.addTable = function addTable(tableObject) {
  //console.log('Adding table: ', tableObject);
  return {
    tableMeta: _extends({}, tableObject),
    type: ACTION_NAMES.TABLE_ADD
  };
};

var removeTable = exports.removeTable = function removeTable(id) {
  return {
    id: id,
    type: ACTION_NAMES.TABLE_REMOVE
  };
};

var loadData = exports.loadData = function loadData(_ref) {
  var questionId = _ref.questionId,
      sortDir = _ref.sortDir,
      isSort = _ref.isSort,
      isReload = _ref.isReload;

  return function (dispatch, getState) {
    var tableState = SELECTORS.getTableForQuestion({
      state: getState(),
      questionId: questionId
    });

    var _tableState = _extends({}, tableState),
        lastRowIndex = _tableState.lastRowIndex,
        action = _tableState.action,
        sortDir = _tableState.sortDir,
        chunkSize = _tableState.chunkSize,
        firstLoad = _tableState.firstLoad;

    if (isSort == true) {
      lastRowIndex = 1;
      action = TABLE_ACTIONS_ENUM.SORTING;
    } else {
      isSort = false;
      sortDir = sortDir || SORT_DIRECTIONS_ENUM.NONE;
    }
    dispatch(tableDataLoadStart(questionId));
    dispatch(updateTableProperties({ sortDir: sortDir, lastRowIndex: lastRowIndex, action: action }));

    var params = {
      questionId: questionId,
      chunkSize: chunkSize,
      lastRowIndex: lastRowIndex,
      action: action,
      sortDir: sortDir
    };

    //console.log('state now: ', getState());

    (0, _api.getTableData)(params).then(function (response) {
      //console.log('Data received: ', response);

      onDataLoadedJquery({ firstLoad: firstLoad, questionId: questionId });

      dispatch(tableDataLoadSuccess({
        response: response,
        questionId: questionId,
        isSort: isSort,
        lastRowIndex: lastRowIndex,
        chunkSize: chunkSize,
        isReload: false
      }));
    });
  };
};

var changeTableSort = exports.changeTableSort = function changeTableSort(_ref2) {
  var questionId = _ref2.questionId,
      sortDir = _ref2.sortDir;

  return function (dispatch, getState) {
    dispatch({
      questionId: questionId,
      sortDir: sortDir,
      type: ACTION_NAMES.TABLE_SORT_CHANGE
    });

    dispatch(loadData({ questionId: questionId, sortDir: sortDir, isSort: true }));
  };
  /* return {
    questionId,
    sortDir,
    type: ACTION_NAMES.TABLE_SORT_CHANGE
  }; */
};
/** ACTIONS END **/

/** REDUCER HELPERS **/
var onTableAdd = function onTableAdd(state, action) {
  var _stateClone = _extends({}, state);
  var meta = _extends({}, action.tableMeta);
  if (state[action.tableMeta.questionId]) {
    //console.log("deleting table from tables state: ", action);

    //_stateClone[action.tableMeta.questionId]['isReload'] = true;
    //delete _stateClone[action.tableMeta.questionId];
  }

  /*  console.log('firstLoad?: ', !!state[action.tableMeta.questionId].firstLoad);
   console.log('isReload?: ', !!state[action.tableMeta.questionId].isReload); */

  var shouldReload = !!state[action.tableMeta.questionId];

  return _extends({}, _stateClone, _defineProperty({}, action.tableMeta.questionId, _extends({}, defaultTableState, action.tableMeta, { isReload: shouldReload
    /* ...{data: []},
    ...{header: []},
    ...{isReload: !!state[action.tableMeta.questionId]} */
  })));
};

var onTableRemove = function onTableRemove(state, action) {
  var _stateClone = _extends({}, state);
  if (_stateClone[action.id]) {
    delete _stateClone[action.id];

    return _extends({}, _stateClone);
  }

  return state;
};

var onTableDataLoadStart = function onTableDataLoadStart(state, action) {
  var questionId = action.questionId;

  var tableState = state[questionId];
  return _extends({}, state, _defineProperty({}, questionId, _extends({}, tableState, {
    loadingData: true,
    isReload: false
  })));
};

var onTableDataLoadEnd = function onTableDataLoadEnd(state, action) {
  var questionId = action.questionId;

  var tableState = state[questionId];
  return _extends({}, state, _defineProperty({}, questionId, _extends({}, tableState, {
    loadingData: false,
    isReload: false
  })));
};

var onTableSortChange = function onTableSortChange(state, action) {
  var questionId = action.questionId,
      sortDir = action.sortDir;

  var tableState = state[questionId];

  return _extends({}, state, _defineProperty({}, questionId, _extends({}, tableState, {
    sortDir: sortDir,
    isReload: false
  })));
};

var onTableDataLoadSuccess = function onTableDataLoadSuccess(state, action) {
  var questionId = action.questionId,
      response = action.response,
      isSort = action.isSort,
      lastRowIndex = action.lastRowIndex,
      chunkSize = action.chunkSize,
      isReload = action.isReload;
  var data = response.data,
      header = response.header,
      hasMoreData = response.hasMoreData,
      sortDir = response.sortDir;


  var tableState = state[questionId];
  var newData = [].concat(_toConsumableArray(tableState.data || []));

  if (state.isReload) {}

  if (!isSort) {
    newData.push.apply(newData, data);
  } else {
    newData = data;
  }

  //console.log('setting new data: ', newData);

  return _extends({}, state, _defineProperty({}, questionId, _extends({}, tableState, { data: newData }, {
    header: header,
    lastRowIndex: lastRowIndex + chunkSize,
    hasMoreData: hasMoreData,
    sortDir: sortDir,
    firstLoad: false,
    loadingData: false,
    isReload: false
  })));
};
/** REDUCER HELPERS END **/

/** REDUCER **/

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case ACTION_NAMES.TABLE_ADD:
      return onTableAdd(state, action);
    case ACTION_NAMES.TABLE_REMOVE:
      return onTableRemove(state, action);
    case ACTION_NAMES.TABLE_DATA_LOAD_START:
      return onTableDataLoadStart(state, action);
    case ACTION_NAMES.TABLE_DATA_LOAD_SUCCESS:
      return onTableDataLoadSuccess(state, action);
    case ACTION_NAMES.TABLE_DATA_LOAD_END:
      return onTableDataLoadEnd(state, action);
    case ACTION_NAMES.TABLE_SORT_CHANGE:
      return onTableSortChange(state, action);
    default:
      return state;
  }
};
/** REDUCER END **/

/* LEGACY CODE, SHOULD BE REMOVED/REFACTORED */


var onDataLoadedJquery = exports.onDataLoadedJquery = function onDataLoadedJquery(_ref3) {
  var questionId = _ref3.questionId,
      firstLoad = _ref3.firstLoad;

  var containerElement = $("#data_" + questionId);
  if (firstLoad) {
    getQualMedia(questionId, containerElement);
  } else {
    $(containerElement).reinitializeScrollPane();
  }
};

var getQualMedia = exports.getQualMedia = function getQualMedia(questionId, containerElement) {
  $("#qualAction").val("getMedia");
  $("#qualQuestionId").val(questionId);
  $("#qualTableForm").ajaxSubmit({
    error: function error(XMLHttpRequest, textStatus, errorThrown) {
      //  eslint-disable-next-line
      if (handleError && typeof handleError === "function") {
        handleError(textStatus); // eslint-disable-line
      }
    },
    success: function success(content) {
      var mediaContainerElement = $("#" + questionId + "_MediaContent");
      mediaContainerElement.html(content);
      TA.QuestionLayout.endLoadingQuestion(questionId); // eslint-disable-line
      $(containerElement).addCustomScrollpane({}, {
        adjustHeight: true
      });

      //TA.Qual.loadQualMedia(questionId, questionId + "_MediaContent", false);// eslint-disable-line
    }
  });

  //loadQualMedia(questionId);
};

/***/ }),

/***/ "4vXW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTranslations = undefined;

var _lodash = __webpack_require__("B1iE");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTranslations = exports.getTranslations = function getTranslations() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _TRANSLATIONS_ = global.LOCALIZATION || {};

  if (path === '') {
    return _TRANSLATIONS_;
  }

  _TRANSLATIONS_ = _lodash2.default.get(_TRANSLATIONS_, path) || {};

  //console.log(_TRANSLATIONS_)

  return _TRANSLATIONS_;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "5am/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__("H5Hs");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement('div', null);

var TimeCell = function (_Component) {
    _inherits(TimeCell, _Component);

    function TimeCell(props) {
        _classCallCheck(this, TimeCell);

        var _this = _possibleConstructorReturn(this, (TimeCell.__proto__ || Object.getPrototypeOf(TimeCell)).call(this, props));

        _this.name = 'TagsCell';
        return _this;
    }

    _createClass(TimeCell, [{
        key: 'render',
        value: function render() {
            var tagToolTipStr = '';
            for (var i = 1; i < this.props.tags.tagsList.length;) {
                tagToolTipStr = tagToolTipStr + (i != 1 ? ' ,' : '') + this.props.tags.tagsList[i];
                i = i + 1;
            }
            var tagsNumberStr = '';
            if (this.props.tags.tagsNum - 1 >= 1) {
                tagsNumberStr = ' (+' + (this.props.tags.tagsNum - 1) + ')';
            }
            if (parseInt(this.props.tags.tagsNum) == 0) {
                return _ref;
            }
            return _react2.default.createElement(
                'div',
                { 'data-title': tagToolTipStr, 'data-hastooltip': 'true', 'data-titleposition': 'top' },
                _react2.default.createElement(
                    'span',
                    null,
                    this.props.tags.mainTag
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    tagsNumberStr
                )
            );
        }
    }]);

    return TimeCell;
}(_react.Component);

exports.default = (0, _reactCssModules2.default)(TimeCell, _styles2.default);

/***/ }),

/***/ "5dsp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchInFilter = exports.applyFilter = exports.loadFilterData = exports.toggleFilter = exports.loadMoreFilterData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__("jsux");

var _constants2 = _interopRequireDefault(_constants);

var _selectors = __webpack_require__("Oe4J");

var SELECTORS = _interopRequireWildcard(_selectors);

var _api = __webpack_require__("9FGC");

var _filters = __webpack_require__("lvnP");

var filterUtils = _interopRequireWildcard(_filters);

var _tables = __webpack_require__("4hlX");

var tablesActions = _interopRequireWildcard(_tables);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = _constants2.default.initialState,
    ACTION_NAMES = _constants2.default.ACTION_NAMES;

/** ACTIONS **/

var updateFilters = function updateFilters(_ref) {
	var filters = _ref.filters,
	    questionId = _ref.questionId;

	return {
		type: ACTION_NAMES.FILTERS_UPDATE,
		filters: [].concat(_toConsumableArray(filters)),
		questionId: questionId
	};
};

var applyFilterSuccess = function applyFilterSuccess(params) {
	return _extends({
		type: ACTION_NAMES.FILTER_APPLY_SUCCESS
	}, params);
};

var hideFiltersInAllTables = function hideFiltersInAllTables() {
	return {
		type: ACTION_NAMES.FILTERS_HIDE_IN_ALL_TABLES
	};
};

var loadMoreFilterData = exports.loadMoreFilterData = function loadMoreFilterData(_ref2) {
	var questionId = _ref2.questionId,
	    chunkSize = _ref2.chunkSize,
	    lastFilterItemIndex = _ref2.lastFilterItemIndex,
	    columnId = _ref2.columnId,
	    isSelectAll = _ref2.isSelectAll,
	    selectAllChanged = _ref2.selectAllChanged,
	    searchQuery = _ref2.searchQuery;

	return function (dispatch, getState) {
		var filters = SELECTORS.getQuestionTableFilters({ state: getState(), questionId: questionId });

		filters = filterUtils.setFilterLoadingValue({ filters: filters, columnId: columnId, value: true });
		dispatch(updateFilters({ filters: filters, questionId: questionId }));

		(0, _api.loadMoreFilter)({
			questionId: questionId,
			chunkSize: chunkSize,
			lastFilterItemIndex: lastFilterItemIndex,
			columnId: columnId,
			isSelectAll: isSelectAll,
			selectAllChanged: selectAllChanged,
			searchQuery: searchQuery
		}).then(function (result) {
			filters = SELECTORS.getQuestionTableFilters({ state: getState(), questionId: questionId });

			var data = result.data;

			var filterObject = _extends({}, filterUtils.getFilterByColumnId(columnId, filters));
			var clientFilterObject = _extends({}, filterUtils.serverObjectToClient(filterObject, data));
			var newOptions = filterObject.options.concat(clientFilterObject.options);

			clientFilterObject.options = [].concat(_toConsumableArray(newOptions));

			filters = filterUtils.overwriteFilter(clientFilterObject, filters);
			filters = filterUtils.setFilterLoadingValue({ filters: filters, columnId: columnId, value: false });
			dispatch(updateFilters({ filters: filters, questionId: questionId }));
		});
	};
};

var toggleFilter = exports.toggleFilter = function toggleFilter(_ref3) {
	var questionId = _ref3.questionId,
	    columnId = _ref3.columnId;

	return function (dispatch, getState) {
		var state = getState();
		var filters = [].concat(_toConsumableArray(SELECTORS.getQuestionTableFilters({ state: state, questionId: questionId })));
		var isFilterExists = filterUtils.isFilterInArray(columnId, filters);
		var filterObject = isFilterExists ? filterUtils.getFilterByColumnId(columnId, filters) : filterUtils.getFilterObject(columnId);

		if (!isFilterExists) {
			filters.push(_extends({}, filterObject));
			//console.log('filter added: ', filterObject, filters);
		}

		dispatch(updateFilters({ filters: filters, questionId: questionId }));

		if (!filterObject.visible) {
			dispatch(hideFiltersInAllTables());
		}

		state = getState();
		filters = [].concat(_toConsumableArray(SELECTORS.getQuestionTableFilters({ state: state, questionId: questionId })));
		var newFiltersArray = filterUtils.setFilterVisibleValue({ filters: filters, columnId: columnId, value: !filterObject.visible });

		//console.log('Getting filters for questions: ', state, questionId);

		dispatch(updateFilters({ filters: [].concat(_toConsumableArray(newFiltersArray)), questionId: questionId }));
	};
};

var loadFilterData = exports.loadFilterData = function loadFilterData(_ref4) {
	var questionId = _ref4.questionId,
	    columnId = _ref4.columnId,
	    searchQuery = _ref4.searchQuery;

	return function (dispatch, getState) {
		var state = getState();
		var filters = [].concat(_toConsumableArray(SELECTORS.getQuestionTableFilters({ state: state, questionId: questionId })));
		var newFiltersArray = filterUtils.setFilterLoadingValue({ filters: filters, columnId: columnId, value: true });

		var params = {
			questionId: questionId,
			columnId: columnId
		};

		if (searchQuery && searchQuery.length > 0) {
			params.searchQuery = searchQuery;
		}

		dispatch(updateFilters({ filters: [].concat(_toConsumableArray(newFiltersArray)), questionId: questionId }));

		//console.log('Getting filter for: ', questionId, columnId, searchQuery, filters);

		(0, _api.getTableFilterData)(params).then(function (result) {
			var data = result.data;

			state = getState();
			//console.log('Filter from server: ', data);
			//console.log('Filter on client: ', filterObject);

			filters = [].concat(_toConsumableArray(SELECTORS.getQuestionTableFilters({ state: state, questionId: questionId })));

			var isError = !data.hasOwnProperty('title');
			var filterObject = _extends({}, filterUtils.getFilterByColumnId(columnId, filters));

			filterObject.error = isError;

			var clientFilterObject = _extends({}, filterUtils.serverObjectToClient(filterObject, data));

			filters = filterUtils.overwriteFilter(clientFilterObject, filters);
			filters = filterUtils.setFilterLoadingValue({ filters: filters, columnId: columnId, value: false });

			dispatch(updateFilters({ filters: filters, questionId: questionId }));
		});
	};
};

var applyFilter = exports.applyFilter = function applyFilter(_ref5) {
	var questionId = _ref5.questionId,
	    filter = _ref5.filter,
	    isSelectAll = _ref5.isSelectAll,
	    selectAllChanged = _ref5.selectAllChanged;

	//console.log('Opachki...');
	return function (dispatch, getState) {
		//console.log('Trying not to obosratsa');
		var isMultichoiceFilterType = filterUtils.isMultichoiceFilterType,
		    isRangeFilterType = filterUtils.isRangeFilterType,
		    clientObjectToServer = filterUtils.clientObjectToServer;
		var columnId = filter.columnId;

		var dataObject = {};

		if (isMultichoiceFilterType(columnId)) {
			dataObject = clientObjectToServer(filter, {});
			dataObject.isSelectAll = isSelectAll;
			dataObject.selectAllChanged = selectAllChanged;
		} else if (isRangeFilterType(columnId)) {
			dataObject = clientObjectToServer(filter, {});
		}

		var serverParams = {
			questionId: questionId,
			columnFilters: [{
				data: JSON.stringify(dataObject),
				name: columnId.toUpperCase()
			}]
		};

		dispatch(toggleFilter({ questionId: questionId, columnId: columnId }));
		dispatch(tablesActions.tableDataLoadStart(questionId));

		(0, _api.applyTableFilter)(serverParams).then(function (response) {
			var data = response.data;
			/*console.log('Filter applied.');
   console.log('Data from server: ', data);
     console.log('Reloading data');*/

			var tableState = SELECTORS.getTableForQuestion({ state: getState(), questionId: questionId });

			var hasMoreData = data.hasMoreData,
			    body = data.body;


			dispatch(applyFilterSuccess({ questionId: questionId, data: body, lastRowIndex: tableState.chunkSize + 1, hasMoreData: hasMoreData }));
			tablesActions.onDataLoadedJquery({ firstLoad: false, questionId: questionId });
		});
	};
};

var searchInFilter = exports.searchInFilter = function searchInFilter(_ref6) {
	var questionId = _ref6.questionId,
	    searchQuery = _ref6.searchQuery,
	    columnId = _ref6.columnId;

	return function (dispatch, getState) {
		var state = getState();
		var filters = SELECTORS.getQuestionTableFilters({ state: state, questionId: questionId });
		filters = filterUtils.setFilterLoadingValue({ filters: filters, questionId: questionId, columnId: columnId });

		//console.log('Searching filter: ', questionId, searchQuery, columnId);

		dispatch(updateFilters({ filters: filters, questionId: questionId }));
		dispatch(loadFilterData({ questionId: questionId, searchQuery: searchQuery, columnId: columnId }));
	};
};
/** ACTIONS END **/

/** REDUCER HELPERS **/
var onTableFiltersUpdate = function onTableFiltersUpdate(state, action) {
	var filters = action.filters,
	    questionId = action.questionId;

	var tableState = _extends({}, state[questionId]);

	tableState.filters = [].concat(_toConsumableArray(filters));

	//console.log('Updating filters: ', tableState);

	return _extends({}, state, _defineProperty({}, questionId, _extends({}, tableState)));
};

var onFilterApplySuccess = function onFilterApplySuccess(state, action) {
	var questionId = action.questionId,
	    tableParams = _objectWithoutProperties(action, ['questionId']);

	var tableState = _extends({}, state[questionId], tableParams, {
		loadingData: false
	});

	return _extends({}, state, _defineProperty({}, questionId, _extends({}, tableState)));
};

var onHideFiltersInAllTables = function onHideFiltersInAllTables(state) {
	var stateClone = _extends({}, state);

	//console.log('State clone: ', stateClone);
	//console.log('Keys: ', Object.keys(stateClone));

	Object.keys(stateClone).forEach(function (key, idx) {
		//console.log(key, idx);
		var tableStateClone = _extends({}, stateClone[key]);

		var _stateClone$key = _extends({}, stateClone[key]),
		    filters = _stateClone$key.filters;

		//console.log('filters: ', filters);

		var shouldHide = filters.filter(function (filter) {
			return filter.visible === true;
		}).length > 0;

		if (shouldHide) {
			tableStateClone.filters = filterUtils.hideAllFilters({ filters: filters });

			stateClone[key] = _extends({}, tableStateClone);
		}
	});

	return stateClone;
};
/** REDUCER HELPERS END **/

/** REDUCER **/

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_NAMES.FILTERS_UPDATE:
			return onTableFiltersUpdate(state, action);
		case ACTION_NAMES.FILTERS_HIDE_IN_ALL_TABLES:
			return onHideFiltersInAllTables(state, action);
		case ACTION_NAMES.FILTER_APPLY_SUCCESS:
			return onFilterApplySuccess(state, action);
		default:
			return state;
	}
};
/** REDUCER END **/

/***/ }),

/***/ "6lnl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__("3bmd");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/*import {FormattedDate} from 'react-intl';*/


var _ref = _react2.default.createElement('br', null);

var TimeCell = function (_Component) {
    _inherits(TimeCell, _Component);

    function TimeCell(props) {
        _classCallCheck(this, TimeCell);

        var _this = _possibleConstructorReturn(this, (TimeCell.__proto__ || Object.getPrototypeOf(TimeCell)).call(this, props));

        _this.name = 'TimeCell';
        return _this;
    }
    //const {time} = props;
    //cellContent = date.toDateString();
    //{date.toDateString()}<br/>{date.toTimeString()}


    _createClass(TimeCell, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'span',
                    null,
                    this.props.timestamp.date
                ),
                _ref,
                _react2.default.createElement(
                    'span',
                    null,
                    this.props.timestamp.time
                )
            );
        }
    }]);

    return TimeCell;
}(_react.Component);

exports.default = (0, _reactCssModules2.default)(TimeCell, _styles2.default);

/***/ }),

/***/ "6mvI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"qual-media-block-wrapper":"styles__qual-media-block-wrapper___2Icaa"};

/***/ }),

/***/ "86gf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CheckboxesPanel_component = __webpack_require__("SxRD");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CheckboxesPanel_component).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "9FGC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.loadQualMedia = exports.loadMoreFilter = exports.applyTableFilter = exports.getTableFilterData = exports.getTableData = undefined;

var _axios = __webpack_require__("dZBD");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BASE_URL = '/main/qualTableAction.do';

var getSITA = function getSITA() {
	return window.document.getElementById('sita').value;
};

var getTableData = exports.getTableData = function getTableData(_ref) {
	var questionId = _ref.questionId,
	    chunkSize = _ref.chunkSize,
	    lastRowIndex = _ref.lastRowIndex,
	    action = _ref.action,
	    sortDir = _ref.sortDir;

	var sita = getSITA(); //TODO: Should be available globally
	var params = {
		action: action,
		questionId: questionId,
		'loginInfo-header': sita,
		chunkSize: chunkSize,
		lastRowIndex: lastRowIndex,
		sortDir: sortDir
	};

	//console.log('With params: ', params);

	return _axios2.default.get(BASE_URL, {
		params: params
	}).then(function (result) {
		var newResult = {};
		newResult.data = result.data && result.data.body ? result.data.body : [];
		newResult.header = result.data.header;
		newResult.hasMoreData = result.data.hasMoreData;
		newResult.sortDir = result.data.sortDir;
		return newResult;
	}).catch(function (error) {
		return error;
	});
};

var getTableFilterData = exports.getTableFilterData = function getTableFilterData(_ref2) {
	var questionId = _ref2.questionId,
	    columnId = _ref2.columnId,
	    searchQuery = _ref2.searchQuery,
	    chunkSize = _ref2.chunkSize,
	    lastRowIndex = _ref2.lastRowIndex;

	var sita = getSITA(); //TODO: Should be available globally
	var action = 'getFilter';
	var params = {
		'action': action,
		columnId: columnId,
		questionId: questionId,
		searchQuery: searchQuery,
		'chunkSize': 10,
		'lastRowIndex': lastRowIndex,
		'loginInfo-header': sita
	};

	return _axios2.default.get(BASE_URL, {
		params: params
	}).then(function (result) {
		return result;
	}).catch(function (error) {
		return error;
	});
};

var applyTableFilter = exports.applyTableFilter = function applyTableFilter(_ref3) {
	var questionId = _ref3.questionId,
	    columnFilters = _ref3.columnFilters,
	    chunkSize = _ref3.chunkSize,
	    lastRowIndex = _ref3.lastRowIndex;

	var sita = getSITA(); //TODO: Should be available globally
	var action = 'applyFilter';
	var params = {
		'action': action,
		questionId: questionId,
		'chunkSize': 10,
		'lastRowIndex': 1,
		filterListJson: JSON.stringify(columnFilters),
		'loginInfo-header': sita
	};

	return _axios2.default.get(BASE_URL, { params: params }).then(function (result) {
		return result;
	}).catch(function (error) {
		return error;
	});
};

var loadMoreFilter = exports.loadMoreFilter = function loadMoreFilter(_ref4) {
	var questionId = _ref4.questionId,
	    columnId = _ref4.columnId,
	    chunkSize = _ref4.chunkSize,
	    lastFilterItemIndex = _ref4.lastFilterItemIndex,
	    columnFilters = _ref4.columnFilters,
	    isSelectAll = _ref4.isSelectAll,
	    selectAllChanged = _ref4.selectAllChanged,
	    searchQuery = _ref4.searchQuery;

	var sita = getSITA(); //TODO: Should be available globally
	var action = 'loadMoreFilter';
	var params = {
		'action': action,
		columnId: columnId,
		questionId: questionId,
		chunkSize: chunkSize,
		'selectAll': isSelectAll,
		selectAllChanged: selectAllChanged,
		searchQuery: searchQuery,
		'lastRowIndex': lastFilterItemIndex,
		'loginInfo-header': sita
	};

	return _axios2.default.get(BASE_URL, { params: params }).then(function (result) {
		return result;
	}).catch(function (error) {
		return error;
	});
};

var loadQualMedia = exports.loadQualMedia = function loadQualMedia(questionId) {
	//console.log('Loading media for question: ', questionId);
	var sita = getSITA(); //TODO: Should be available globally
	var action = 'getMediaFiles';

	var _startTS = new Date();

	var params = {
		action: action,
		questionId: questionId,
		'loginInfo-header': sita
	};

	return _axios2.default.get(BASE_URL, {
		params: params
	}).then(function (result) {
		return result;
	}).catch(function (error) {
		return error;
	});
};

exports.default = {
	getTableData: getTableData, getTableFilterData: getTableFilterData, applyTableFilter: applyTableFilter, loadMoreFilter: loadMoreFilter, loadQualMedia: loadQualMedia
};

/***/ }),

/***/ "ES2g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.components = exports.api = undefined;

var _Table_container = __webpack_require__("tgbF");

var _Table_container2 = _interopRequireDefault(_Table_container);

var _MediaBlock_container = __webpack_require__("/ZeP");

var _MediaBlock_container2 = _interopRequireDefault(_MediaBlock_container);

var _api = __webpack_require__("9FGC");

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var api = exports.api = _api2.default;

var components = exports.components = {
  QualTable: _Table_container2.default,
  QualMediaBlock: _MediaBlock_container2.default
};

exports.default = {
  api: api,
  components: {
    QualTable: _Table_container2.default,
    QualMediaBlock: _MediaBlock_container2.default
  }
};

/***/ }),

/***/ "GSXd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cell":"styles__cell___32LRY","timestamp":"styles__timestamp___28d7h","text":"styles__text___2UReZ","panelists":"styles__panelists___tMfGd","media":"styles__media___2T7X9","comment":"styles__comment___1E63z","likes":"styles__likes___UwORw","tags":"styles__tags___ErELE","sentiments":"styles__sentiments___3b5Sw","actions":"styles__actions___XkXEn"};

/***/ }),

/***/ "Ggrw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"QualTableHeader":"styles__QualTableHeader___2hVII","row":"styles__row___3_QTs"};

/***/ }),

/***/ "H5Hs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J9Od":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("fpuT");

var _reduxImmutableStateInvariant = __webpack_require__("kn7R");

var _reduxImmutableStateInvariant2 = _interopRequireDefault(_reduxImmutableStateInvariant);

var _reduxThunk = __webpack_require__("i/8a");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = __webpack_require__("XYJE");

var _rootReducer = __webpack_require__("KSPs");

var _rootReducer2 = _interopRequireDefault(_rootReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureStoreProd(initialState) {
  var middlewares = [
  // Add other middleware on this line...

  // thunk middleware can also accept an extra argument to be passed to each thunk action
  // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument


  // thunk middleware can also accept an extra argument to be passed to each thunk action
  // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
  _reduxThunk2.default];

  return (0, _redux.createStore)(_rootReducer2.default, initialState, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middlewares)));
}

function configureStoreDev() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var middlewares = [
  // Add other middleware on this line...
  (0, _reduxLogger.createLogger)(),
  // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
  (0, _reduxImmutableStateInvariant2.default)(), _reduxThunk2.default];

  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose; // add support for Redux dev tools
  var store = (0, _redux.createStore)(_rootReducer2.default, initialState, composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));

  if (false) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./rootReducer', function () {
      var nextReducer = require('./rootReducer').default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

var configureStore =  true ? configureStoreProd : configureStoreDev;

exports.default = configureStore;

/***/ }),

/***/ "JkW7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apis = exports.helpers = undefined;

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("NKHc");

var _reactRedux = __webpack_require__("jYI/");

var _configureStore = __webpack_require__("J9Od");

var _configureStore2 = _interopRequireDefault(_configureStore);

var _reactInterface = __webpack_require__("KUK8");

var _reactInterface2 = _interopRequireDefault(_reactInterface);

var _IntlProvider = __webpack_require__("BnZ4");

var _IntlProvider2 = _interopRequireDefault(_IntlProvider);

var _App = __webpack_require__("UuX/");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!global._babelPolyfill) {
  __webpack_require__("wllv");
} // eslint-disable-line no-unused-vars
var helpers = _reactInterface2.default.helpers,
    apis = _reactInterface2.default.apis;
exports.helpers = helpers;
exports.apis = apis;

/*******/

var translations = {

  'translation': 'my first translation',
  'translationWithParams': 'my second translation. arg0={0}, arg1={1}'
};

/*************/

var bodyContainerHTML = document.getElementById('bodyContainer').innerHTML;

(0, _reactDom.render)(_react2.default.createElement(
  _reactRedux.Provider,
  { store: (0, _configureStore2.default)() },
  _react2.default.createElement(
    _IntlProvider2.default,
    {
      translations: translations },
    _react2.default.createElement(_App.LocalizedApp, null)
  )
), document.getElementById('bodyContainer'));
document.getElementById('ta-react-app').insertAdjacentHTML('beforeend', bodyContainerHTML);

if (false) {
  module.hot.accept();
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "KSPs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__("fpuT");

var _ducks = __webpack_require__("3nYV");

var _ducks2 = _interopRequireDefault(_ducks);

var _ducks3 = __webpack_require__("S7So");

var _ducks4 = _interopRequireDefault(_ducks3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (0, _redux.combineReducers)(_defineProperty({
  report: _ducks2.default
}, _ducks3.NAME, _ducks4.default));

/***/ }),

/***/ "KUK8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("NKHc");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _components = __webpack_require__("Q+ez");

var _components2 = _interopRequireDefault(_components);

var _hocs = __webpack_require__("swAs");

var _hocs2 = _interopRequireDefault(_hocs);

var _qual = __webpack_require__("ES2g");

var _configureStore = __webpack_require__("J9Od");

var _configureStore2 = _interopRequireDefault(_configureStore);

var _utils = __webpack_require__("4vXW");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var allComponents = _extends({}, _components2.default, _hocs2.default, _qual.components);

var store = (0, _configureStore2.default)();

//console.log(allComponents);

var renderComponent = function renderComponent(component, parentElement) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  //console.log('trying to unmount component at: ', parentElement);
  //console.log('parentNode: ', ReactDOM.findDOMNode(parentElement));
  unmountComponent(_reactDom2.default.findDOMNode(parentElement));

  var requiredComponent = allComponents[component];

  var withTranslationsHOC = allComponents.withTranslations;

  //const reactElement = React.createElement(allComponents[component], props);

  var translatedElement = _react2.default.createElement(withTranslationsHOC(allComponents.withStore(store)(requiredComponent)), props);

  //const withStoreElement = React.createElement(allComponents.withStore(configureStore())(allComponents[component]), props);

  //console.log('Rendering translated component: ', translatedElement);

  _reactDom2.default.render(translatedElement, parentElement);
};

var unmountComponent = function unmountComponent(parentElement) {
  //console.log('unmounting: ', parentElement);
  _reactDom2.default.unmountComponentAtNode(_reactDom2.default.findDOMNode(parentElement));
};

exports.default = {
  helpers: {
    renderComponent: renderComponent,
    unmountComponent: unmountComponent,
    getTranslations: _utils.getTranslations
  },
  apis: {
    qual: _qual.api
  }
};

/***/ }),

/***/ "Lsr9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__("c4e5");

var _styles2 = _interopRequireDefault(_styles);

var _filters = __webpack_require__("lvnP");

var _MultipleChoice = __webpack_require__("QJGd");

var _MultipleChoice2 = _interopRequireDefault(_MultipleChoice);

var _Range = __webpack_require__("xbO0");

var _Range2 = _interopRequireDefault(_Range);

var _Preloader = __webpack_require__("s06j");

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref3 = _react2.default.createElement(
  "div",
  { styleName: "loading-wrapper" },
  _react2.default.createElement(_Preloader2.default, null)
);

var ColumnFilter = function ColumnFilter(props) {
  var filterElement = null;

  var _props$filterData = props.filterData,
      filterData = _props$filterData === undefined ? null : _props$filterData,
      columnName = props.columnName,
      _props$searchInFilter = props.searchInFilter,
      searchInFilter = _props$searchInFilter === undefined ? function (filterValue) {} : _props$searchInFilter,
      _props$applyFilter = props.applyFilter,
      applyFilter = _props$applyFilter === undefined ? function (_ref) {
    var filter = _ref.filter,
        items = _ref.items;
  } : _props$applyFilter,
      _props$closeFilter = props.closeFilter,
      closeFilter = _props$closeFilter === undefined ? function () {} : _props$closeFilter,
      _props$loadMore = props.loadMore,
      loadMore = _props$loadMore === undefined ? function (_ref2) {
    var chunkSize = _ref2.chunkSize,
        lastFilterItemIndex = _ref2.lastFilterItemIndex,
        isSelectAll = _ref2.isSelectAll,
        selectAllChanged = _ref2.selectAllChanged,
        searchQuery = _ref2.searchQuery;
  } : _props$loadMore;

  //console.log('filterData: ', filterData);

  var filterType = (0, _filters.getFilterTypeByColumnId)(columnName);

  var _ref4 = _react2.default.createElement(_MultipleChoice2.default, {
    closeFilter: closeFilter,
    searchInFilter: searchInFilter,
    applyFilter: applyFilter,
    filterData: filterData,
    loadMore: loadMore
  });

  var _ref5 = _react2.default.createElement(_Range2.default, {
    applyFilter: applyFilter,
    closeFilter: closeFilter,
    filterData: filterData
  });

  var getComponent = function getComponent() {
    if (filterData.loading === true) {
      return _ref3;
    } else if (filterData.error === true) {
      return _react2.default.createElement(
        "div",
        {
          styleName: "loading-wrapper",
          style: { color: "red", fontWeight: "bold" }
        },
        "Error"
      );
    }
    var filterComponent = null;

    switch (filterType) {
      case _filters.FILTER_TYPES.MULTICHOICE:
        filterComponent = _ref4;
        break;
      case _filters.FILTER_TYPES.RANGE:
        filterComponent = _ref5;
        break;
    }

    return filterComponent;
  };

  var setFilterElement = function setFilterElement(element) {
    //console.log("element: ", element);
    filterElement = element;

    if (!filterElement) {
      return;
    }

    filterElement.classList.add("below");
    filterElement.classList.remove("above");
    filterElement.classList.add("to-right");
    filterElement.classList.remove("to-left");

    setTimeout(function () {
      if (!filterElement) {
        return;
      }
      if (isAbove()) {
        filterElement.classList.add("above");
        filterElement.classList.remove("below");
      } else {
        filterElement.classList.add("below");
        filterElement.classList.remove("above");
      }

      if (isToLeft()) {
        filterElement.classList.add("to-left");
        filterElement.classList.remove("to-right");
      } else {
        filterElement.classList.add("to-right");
        filterElement.classList.remove("to-left");
      }
    });
  };

  var isAbove = function isAbove() {
    var rv = false;

    var documentRect = document.body.getBoundingClientRect();
    var filterRect = filterElement.getBoundingClientRect();

    //console.log(documentRect, filterRect);

    //console.log('heights: ', filterRect.y + filterRect.height, documentRect.height);

    if (filterRect.y + filterRect.height > documentRect.height) {
      rv = true;
    }

    return rv;
  };

  var isToLeft = function isToLeft() {
    var rv = false;

    var documentRect = document.body.getBoundingClientRect();
    var filterRect = filterElement.getBoundingClientRect();

    //console.log(documentRect, filterRect);

    //console.log('widths: ', filterRect.x + filterRect.width, documentRect.width);

    if (filterRect.x + filterRect.width > documentRect.width) {
      rv = true;
    }

    return rv;
  };

  var additionalClasses = (0, _classnames2.default)({
    "table-column-filter": true,
    "multichoice-filter": (0, _filters.isMultichoiceFilterType)(columnName),
    "range-filter": (0, _filters.isRangeFilterType)(columnName)
    /* "to-right": !isToLeft(),
    below: !isAbove(),
    "to-left": isToLeft(),
    above: isAbove() */
  });

  return _react2.default.createElement(
    "div",
    { styleName: additionalClasses, ref: setFilterElement },
    getComponent()
  );
};

exports.default = (0, _reactCssModules2.default)(ColumnFilter, _extends({}, _styles2.default), { allowMultiple: true });

/***/ }),

/***/ "M7Uv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactCustomScrollbars = __webpack_require__("E5f5");

var _Button = __webpack_require__("Cpum");

var _Button2 = _interopRequireDefault(_Button);

var _Checkbox = __webpack_require__("+MyX");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _CheckboxesPanel = __webpack_require__("86gf");

var _CheckboxesPanel2 = _interopRequireDefault(_CheckboxesPanel);

var _SearchBox = __webpack_require__("dCpF");

var _SearchBox2 = _interopRequireDefault(_SearchBox);

var _lodash = __webpack_require__("B1iE");

var _styles = __webpack_require__("fDSs");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/*import InputField from 'toluna-react-components/Inputs/InputField';
 import Icon from 'toluna-react-components/Icon';
 import InputFieldWithIcon from 'toluna-react-components/Inputs/InputFieldWithIcon';
 import ScrollBar from 'toluna-react-components/Containers/Scroll';*/


var _ref = _react2.default.createElement(
	'span',
	{ styleName: 'loading-ph' },
	_react2.default.createElement('i', { className: 'fa fa-spinner fa-spin fa-3x fa-fw' })
);

var MultipleChoiceFilter = function (_Component) {
	_inherits(MultipleChoiceFilter, _Component);

	function MultipleChoiceFilter(props) {
		_classCallCheck(this, MultipleChoiceFilter);

		var _this = _possibleConstructorReturn(this, (MultipleChoiceFilter.__proto__ || Object.getPrototypeOf(MultipleChoiceFilter)).call(this, props));

		_this.name = 'MultipleChoiceFilter';

		var _this$props$filterDat = _extends({}, _this.props.filterData),
		    title = _this$props$filterDat.title,
		    _this$props$filterDat2 = _this$props$filterDat.options,
		    options = _this$props$filterDat2 === undefined ? [] : _this$props$filterDat2,
		    searchQuery = _this$props$filterDat.searchQuery,
		    isAllSelected = _this$props$filterDat.isAllSelected,
		    _this$props$filterDat3 = _this$props$filterDat.selectAllTitle,
		    selectAllTitle = _this$props$filterDat3 === undefined ? '(' : _this$props$filterDat3,
		    totalFilterItemCount = _this$props$filterDat.totalFilterItemCount,
		    _this$props$filterDat4 = _this$props$filterDat.clearStr,
		    clearStr = _this$props$filterDat4 === undefined ? '' : _this$props$filterDat4,
		    _this$props$filterDat5 = _this$props$filterDat.noOptionsStr,
		    noOptionsStr = _this$props$filterDat5 === undefined ? '' : _this$props$filterDat5,
		    _this$props$filterDat6 = _this$props$filterDat.loadMoreStr,
		    loadMoreStr = _this$props$filterDat6 === undefined ? '' : _this$props$filterDat6,
		    _this$props$filterDat7 = _this$props$filterDat.applyStr,
		    applyStr = _this$props$filterDat7 === undefined ? '' : _this$props$filterDat7,
		    _this$props$filterDat8 = _this$props$filterDat.cancelStr,
		    cancelStr = _this$props$filterDat8 === undefined ? '' : _this$props$filterDat8,
		    filterSelectionCountStr = _this$props$filterDat.filterSelectionCountStr,
		    filterAllSelectionCountStr = _this$props$filterDat.filterAllSelectionCountStr,
		    selectAllCountStr = _this$props$filterDat.selectAllCountStr,
		    hasMore = _this$props$filterDat.hasMore;

		_this.closeFilter = _this.closeFilter.bind(_this);
		/*this.buildFilterOptions = this.buildFilterOptions.bind(this);*/
		_this.getButtonsBlock = _this.getButtonsBlock.bind(_this);
		_this.onItemValueChange = _this.onItemValueChange.bind(_this);
		_this.onSearchValueChange = _this.onSearchValueChange.bind(_this);
		_this.onSearchKeyUp = _this.onSearchKeyUp.bind(_this);
		_this.onSearchApply = _this.onSearchApply.bind(_this);
		_this.onFilterApply = _this.onFilterApply.bind(_this);
		_this.onLoadMore = _this.onLoadMore.bind(_this);

		_this.toggleSelectAll = _this.toggleSelectAll.bind(_this);
		_this.isAllSelected = _this.isAllSelected.bind(_this);

		_this.onToggleAllVisibleValues = _this.onToggleAllVisibleValues.bind(_this);

		var optionsClone = [].concat(_toConsumableArray(options)).map(function (option) {
			return _extends({}, option);
		});

		_this.state = {
			filterValue: searchQuery || '',
			title: title,
			options: optionsClone,
			isSelectAll: isAllSelected || false,
			selectAllChanged: false,
			selectAllText: selectAllTitle,
			totalFilterItemCount: totalFilterItemCount,
			clearStr: clearStr,
			loadMoreStr: loadMoreStr,
			applyStr: applyStr,
			cancelStr: cancelStr,
			noOptionsStr: noOptionsStr,
			filterSelectionCountStr: filterSelectionCountStr,
			filterAllSelectionCountStr: filterAllSelectionCountStr,
			selectAllCountStr: selectAllCountStr,
			hasMore: _this.props.filterData.hasMore,
			chunkSize: 10,
			searchQuery: searchQuery,
			lastFilterItemIndex: _this.props.filterData.columnId == 'tags' ? options.length : options.length + 1,
			showViewMoreLoadingIcon: false
		};
		return _this;
	}

	_createClass(MultipleChoiceFilter, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.isAllSelected(this.state.options)) {
				//this.setState({isSelectAll: true});
			}
			if (this.state.isSelectAll === true) {
				//this.toggleSelectAll(this.state.isSelectAll);
			} else if (this.isAllSelected()) {
				/* this.setState({
     isSelectAll: true
     });*/
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var _this2 = this;

			var stateObject = {};

			if (nextProps) {
				if (JSON.stringify(nextProps.filterData.options) !== JSON.stringify(this.props.filterData.options)) {
					/*stateObject.isSelectAll = this.isAllSelected(nextProps.filterData.options);*/
					stateObject.options = nextProps.filterData.options;
					stateObject.lastFilterItemIndex = this.props.filterData.columnId == 'tags' ? stateObject.options.length : stateObject.options.length + 1, this.setState({
						showViewMoreLoadingIcon: false,
						hasMore: this.props.filterData.hasMore
					});
				}
				if (JSON.stringify(nextProps.filterData.searchQuery) !== JSON.stringify(this.props.filterData.searchQuery)) {
					stateObject.searchQuery = nextProps.filterData.searchQuery;
				}
			}

			this.setState(_extends({}, stateObject), function (state) {
				if (nextProps.filterData.isAllSelected !== _this2.state.isSelectAll) {}
			}
			//this.toggleSelectAll(nextProps.filterData.selectAll);
			);
		}
	}, {
		key: 'render',
		value: function render() {
			//console.log(this.state);
			var selectedOptionsCount = this.state.options.filter(function (option) {
				return option.selected === true;
			}).length;

			//console.log(this.state.isSelectAll, this.state.selectAllChanged);
			var less = this.props.filterData.columnId == 'tags' ? 1 : 0;

			var _state = this.state,
			    title = _state.title,
			    filterValue = _state.filterValue,
			    options = _state.options,
			    isSelectAll = _state.isSelectAll,
			    selectAllText = _state.selectAllText,
			    totalFilterItemCount = _state.totalFilterItemCount,
			    clearStr = _state.clearStr,
			    noOptionsStr = _state.noOptionsStr,
			    filterSelectionCountStr = _state.filterSelectionCountStr,
			    filterAllSelectionCountStr = _state.filterAllSelectionCountStr,
			    selectAllCountStr = _state.selectAllCountStr,
			    hasMore = _state.hasMore;


			return _react2.default.createElement(
				'div',
				{ styleName: 'multiple-choice-filter' },
				_react2.default.createElement(
					'div',
					{ styleName: 'title' },
					title
				),
				_react2.default.createElement(_SearchBox2.default, {
					value: filterValue,
					onValueChange: this.onSearchValueChange,
					onKeyUp: this.onSearchKeyUp,
					onApply: this.onSearchApply,
					searchPh: this.props.filterData.searchPh
				}),
				options &&
				//options.length > 0 &&
				_react2.default.createElement(_CheckboxesPanel2.default, {
					options: options,
					isSelectAll: isSelectAll,
					selectAllText: selectAllText,
					onItemValueChange: this.onItemValueChange,
					onToggleSelectAll: this.toggleSelectAll,
					onToggleAllVisibleValues: this.onToggleAllVisibleValues,
					totalFilterItemCount: totalFilterItemCount + (this.props.filterData.columnId == 'tags' ? 1 : 0),
					clearStr: clearStr,
					noOptionsStr: noOptionsStr,
					filterSelectionCountStr: filterSelectionCountStr,
					filterAllSelectionCountStr: filterAllSelectionCountStr,
					selectAllCountStr: selectAllCountStr,
					hasMore: hasMore
				}),
				this.props.filterData.hasMore == true && this.getLoadMoreBlock(),
				this.getButtonsBlock()
			);
		}
	}, {
		key: 'closeFilter',
		value: function closeFilter() {
			this.props.closeFilter();
		}
	}, {
		key: 'isAllSelected',
		value: function isAllSelected(options) {
			var isAllSelected = true;
			var list = options ? options : this.state.options;

			if (options) {}

			for (var i = 0; i < list.length; i++) {
				var option = list[i];
				isAllSelected = isAllSelected && option.selected;

				//console.log(option.selected);
			}
			//console.log(isAllSelected);
			return isAllSelected;
		}
	}, {
		key: 'onToggleAllVisibleValues',
		value: function onToggleAllVisibleValues(explicitValue) {
			var options = this.state.options;

			var newOptions = [];
			var isAllSelected = this.isAllSelected();

			if (typeof explicitValue === 'boolean' && explicitValue === true) {
				/*newIsSelectAll = explicitValue;
     console.log('Setting explicit selectAll: ', explicitValue);*/
			}

			[].concat(_toConsumableArray(options)).map(function (option) {
				option.selected = !isAllSelected;
				newOptions.push(option);
			});

			this.setState({ options: newOptions, isSelectAll: !isAllSelected });
		}
	}, {
		key: 'toggleSelectAll',
		value: function toggleSelectAll(explicitValue) {
			var _state2 = this.state,
			    options = _state2.options,
			    isSelectAll = _state2.isSelectAll;

			var newOptions = [];
			var newIsSelectAll = !isSelectAll;

			if (typeof explicitValue === 'boolean' && explicitValue === true) {
				newIsSelectAll = explicitValue;
			}

			[].concat(_toConsumableArray(options)).map(function (option) {
				option.selected = newIsSelectAll;
				newOptions.push(option);
			});

			this.setState({ options: newOptions, isSelectAll: newIsSelectAll, selectAllChanged: true });
		}
	}, {
		key: 'getButtonsBlock',
		value: function getButtonsBlock() {
			//console.log('Options: ', this.state.options);
			var canApply = this.state.options.filter(function (option) {
				return option.selected === true;
			}).length > 0;
			return _react2.default.createElement(
				'div',
				{ styleName: 'buttons-block' },
				_react2.default.createElement(_Button2.default, {
					styleName: 'btnCancel',
					onClick: this.closeFilter,
					buttonStyle: _Button2.default.BUTTON_STYLE.CENTERED_CONTENT,
					text: this.props.filterData.cancelStr,
					small: true
				}),
				_react2.default.createElement(_Button2.default, {
					disabled: !canApply,
					styleName: 'btnApply',
					onClick: this.onFilterApply,
					buttonStyle: _Button2.default.BUTTON_STYLE.RECTANGLE,
					text: this.props.filterData.applyStr,
					small: true,
					primary: true
				})
			);
		}
	}, {
		key: 'getLoadMoreBlock',
		value: function getLoadMoreBlock() {
			return _react2.default.createElement(
				'div',
				{ styleName: 'load-more-block' },
				this.state.showViewMoreLoadingIcon && _ref,
				_react2.default.createElement(_Button2.default, { styleName: 'btnLoadMore', onClick: this.onLoadMore, buttonStyle: _Button2.default.BUTTON_STYLE.OVAL_WITH_ICON,
					iconName: 'plus', iconType: 'toluna',
					text: this.props.filterData.loadMoreStr, small: true })
			);
		}
	}, {
		key: 'onItemValueChange',
		value: function onItemValueChange(item) {
			//console.log('Value changed for: ', item);
			var selected = item.selected,
			    name = item.name,
			    id = item.id;

			var optionsClone = [].concat(_toConsumableArray(this.state.options));
			var changedOption = (0, _lodash.find)(optionsClone, { id: id });

			if (changedOption) {
				changedOption.selected = !changedOption.selected;

				this.setState({ options: optionsClone, isSelectAll: this.isAllSelected(optionsClone) });
			}
		}
	}, {
		key: 'onSearchKeyUp',
		value: function onSearchKeyUp(evt) {
			if (evt.keyCode === 13) {
				this.props.searchInFilter(evt.target.value);
			}
		}
	}, {
		key: 'onSearchValueChange',
		value: function onSearchValueChange(evt) {
			//console.log('ValueChange: ', evt);
			this.setState({
				filterValue: evt.target.value
			});
		}
	}, {
		key: 'onSearchApply',
		value: function onSearchApply(evt) {
			this.props.searchInFilter(this.state.filterValue);
		}
	}, {
		key: 'onLoadMore',
		value: function onLoadMore(evt) {
			this.setState({
				showViewMoreLoadingIcon: true
			});
			this.props.loadMore({
				chunkSize: this.state.chunkSize,
				lastFilterItemIndex: this.state.lastFilterItemIndex,
				isSelectAll: this.state.isSelectAll,
				selectAllChanged: this.state.selectAllChanged,
				searchQuery: this.state.searchQuery
			});
		}
	}, {
		key: 'onFilterApply',
		value: function onFilterApply(evt) {
			this.props.applyFilter({
				options: [].concat(_toConsumableArray(this.state.options)),
				isSelectAll: this.state.isSelectAll,
				selectAllChanged: this.state.selectAllChanged
			});
		}
	}]);

	return MultipleChoiceFilter;
}(_react.Component);

exports.default = (0, _reactCssModules2.default)(MultipleChoiceFilter, _extends({}, _styles2.default), { allowMultiple: true });

/***/ }),

/***/ "MB5U":
/***/ (function(module, exports) {

module.exports = "/assets/images/loading.gif";

/***/ }),

/***/ "NRNw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _TableColumnFilter_component = __webpack_require__("Lsr9");

var _TableColumnFilter_component2 = _interopRequireDefault(_TableColumnFilter_component);

var _filters = __webpack_require__("lvnP");

var filterUtils = _interopRequireWildcard(_filters);

var _styles = __webpack_require__("GSXd");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement("i", { className: "fa fa-sort-asc" });

var _ref2 = _react2.default.createElement("i", { className: "fa fa-sort-desc" });

var _ref3 = _react2.default.createElement("i", { className: "fa fa-sort " });

var TableHeaderCell = function (_Component) {
  _inherits(TableHeaderCell, _Component);

  function TableHeaderCell(props) {
    _classCallCheck(this, TableHeaderCell);

    var _this = _possibleConstructorReturn(this, (TableHeaderCell.__proto__ || Object.getPrototypeOf(TableHeaderCell)).call(this, props));

    _this.displayName = 'TableHeaderCell_container';
    _this.state = {
      filterVisible: props.filter && props.filter.visible,
      isSortColumn: true,
      sortingClass: "fa fa-caret-down",
      sortDir: _this.props.sortDir,
      filterAplayed: _this.props.colData.filterAplayed
      //filterData: this.props.filterData
    };

    _this.closeFilter = _this.closeFilter.bind(_this);
    _this.toggleSortComponent = _this.toggleSortComponent.bind(_this);
    _this.getColumnIcons = _this.getColumnIcons.bind(_this);
    _this.toggleFilterComponent = _this.toggleFilterComponent.bind(_this);
    _this.getFilterComponent = _this.getFilterComponent.bind(_this);
    _this.searchInFilter = _this.searchInFilter.bind(_this);
    _this.applyFilter = _this.applyFilter.bind(_this);
    _this.loadMore = _this.loadMore.bind(_this);
    return _this;
  }

  _createClass(TableHeaderCell, [{
    key: "toggleSortComponent",
    value: function toggleSortComponent() {
      var sortDir = "";
      var options = { sortingClass: "", sortDir: "" };

      if (this.state.sortDir === "asc") {
        sortDir = "desc";
        options = { sortingClass: "fa fa-sort-desc", sortDir: sortDir };
        /* this.setState(
          { sortingClass: "fa fa-sort-desc", sortDir },
          () => {
        console.log('proceeding sort action');
        }
        ); */
      } else if (this.state.sortDir === "desc") {
        sortDir = "";
        options = { sortingClass: "fa fa-sort", sortDir: sortDir };
        /* this.setState(
          { sortingClass: "fa fa-sort", sortDir },
          () => {
        console.log('proceeding sort action');
        }
        ); */
      } else {
        sortDir = "asc";
        options = { sortingClass: "fa fa-sort-desc", sortDir: sortDir };
        /* this.setState(
          { sortingClass: "fa fa-sort-desc", sortDir },
          () => {
        console.log('proceeding sort action');
        }
        ); */
      }

      this.setState(options, this.props.onSortToggle(this.state.sortDir, true));
    }
  }, {
    key: "toggleFilterComponent",
    value: function toggleFilterComponent() {
      this.props.toggleFilter(this.props.colData.key.toLowerCase());
      /*if (this.props.filter && this.props.filter.visible === true) {
      return;
      }
      this.props.getFilter({columnId: this.props.colData.key.toLowerCase()});*/
    }
  }, {
    key: "closeFilter",
    value: function closeFilter() {
      this.toggleFilterComponent();
    }
  }, {
    key: "getColumnIcons",
    value: function getColumnIcons(isSort, filterable) {
      //return (<i className="fa fa-filter"/>);
      var filterIconClasses = (0, _classnames2.default)({
        'fa fa-filter': true,
        'visible-filter': this.props.filter && this.props.filter.visible === true,
        'filter-aplayed': this.state.filterAplayed
      });

      var filterArrowIconClasses = (0, _classnames2.default)({
        'fa fa-sort-desc': true,
        'visible-filter': this.props.filter && this.props.filter.visible === true,
        'filter-aplayed': this.state.filterAplayed
      });

      if (isSort) {
        if (this.state.sortDir === "asc") {
          return _ref;
        } else if (this.state.sortDir === "desc") {
          return _ref2;
        } else {
          return _ref3;
        }
      } else if (filterable === true) {
        return _react2.default.createElement(
          "span",
          null,
          _react2.default.createElement("i", { className: filterArrowIconClasses }),
          _react2.default.createElement("i", { className: filterIconClasses })
        );
        //return null;
      } else {
        return null;
      }
    }
  }, {
    key: "getFilterComponent",
    value: function getFilterComponent(filterable) {
      if (this.props.filter === null || this.props.filter.visible === false || filterable === false) {
        return null;
      }
      return _react2.default.createElement(_TableColumnFilter_component2.default, {
        closeFilter: this.closeFilter,
        applyFilter: this.applyFilter,
        searchInFilter: this.searchInFilter,
        columnName: this.props.colData.key.toLowerCase(),
        filterData: this.props.filter,
        loadMore: this.loadMore
      });
    }
  }, {
    key: "searchInFilter",
    value: function searchInFilter(filterValue) {
      this.props.searchInFilter({
        searchQuery: filterValue,
        columnId: this.props.colData.key.toLowerCase()
      });
    }
  }, {
    key: "loadMore",
    value: function loadMore(_ref4) {
      var chunkSize = _ref4.chunkSize,
          lastFilterItemIndex = _ref4.lastFilterItemIndex,
          isSelectAll = _ref4.isSelectAll,
          selectAllChanged = _ref4.selectAllChanged,
          searchQuery = _ref4.searchQuery;

      this.props.loadMore({
        chunkSize: chunkSize,
        lastFilterItemIndex: lastFilterItemIndex,
        columnId: this.props.colData.key.toLowerCase(),
        isSelectAll: isSelectAll,
        selectAllChanged: selectAllChanged,
        searchQuery: searchQuery
      });
    }
  }, {
    key: "applyFilter",
    value: function applyFilter(_ref5) {
      var isSelectAll = _ref5.isSelectAll,
          selectAllChanged = _ref5.selectAllChanged,
          options = _ref5.options,
          items = _ref5.items,
          params = _objectWithoutProperties(_ref5, ["isSelectAll", "selectAllChanged", "options", "items"]);

      var filter = _extends({}, this.props.filter);

      if (filterUtils.isMultichoiceFilterType(filter.columnId)) {
        filter.options = options;
        this.setState({ filterAplayed: !isSelectAll });
      } else if (filterUtils.isRangeFilterType(filter.columnId)) {
        var isRangeFilterAplayed = !(items.from == this.props.filter.min && items.to == this.props.filter.max);
        this.setState({ filterAplayed: isRangeFilterAplayed });
        filter.from = items.from;
        filter.to = items.to;
      }
      this.props.applyFilter({ filter: filter, isSelectAll: isSelectAll, selectAllChanged: selectAllChanged });
    }
  }, {
    key: "render",
    value: function render() {
      //console.log(this.props);

      //const styleObject = {'background': 'red', color: 'white'};

      var cellStyleName = "cell " + this.props.colData.key;
      var onTblColClick = this.toggleFilterComponent;
      var isSortAction = this.props.colData.key == "timestamp";
      if (isSortAction) {
        onTblColClick = this.toggleSortComponent;
      }
      return _react2.default.createElement(
        "th",
        { styleName: cellStyleName },
        _react2.default.createElement(
          "span",
          { styleName: "text" },
          this.props.colData.label
        ),
        _react2.default.createElement(
          "div",
          { styleName: "actions", onClick: onTblColClick },
          this.getColumnIcons(isSortAction, this.props.colData.filterable)
        ),
        this.getFilterComponent(this.props.colData.filterable)
      );
    }
  }]);

  return TableHeaderCell;
}(_react.Component);

exports.default = (0, _reactCssModules2.default)(TableHeaderCell, _styles2.default, { allowMultiple: true });

/***/ }),

/***/ "NaHU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"checkboxes-panel-wrapper":"styles__checkboxes-panel-wrapper___29x37","helper-selection-block":"styles__helper-selection-block___1aBgV","inner-block":"styles__inner-block___J8v7Y","left-block":"styles__left-block___3P_QC","right-block":"styles__right-block___3WDvQ","helper-no-selection-block":"styles__helper-no-selection-block___3KKbw","choice-item-select-all":"styles__choice-item-select-all___2CXIb","scrollbar":"styles__scrollbar___tckct","choices-wrapper":"styles__choices-wrapper___1Z-_y","choice-item":"styles__choice-item___295N3"};

/***/ }),

/***/ "NddO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("jYI/");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (store) {
  return function (WrappedComponent) {
    return function (_Component) {
      _inherits(WithStore, _Component);

      function WithStore() {
        _classCallCheck(this, WithStore);

        return _possibleConstructorReturn(this, (WithStore.__proto__ || Object.getPrototypeOf(WithStore)).apply(this, arguments));
      }

      _createClass(WithStore, [{
        key: 'render',
        value: function render() {

          //console.log(WrappedComponent, this.props);
          return _react2.default.createElement(
            _reactRedux.Provider,
            { store: store },
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return WithStore;
    }(_react.Component);
  };
};

/***/ }),

/***/ "Oe4J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getQuestionTableFilters = exports.makeGetTableForQuestion = exports.getTableForQuestion = undefined;

var _reselect = __webpack_require__("SdCE");

var _isEqual = __webpack_require__("R6wa");

var _isEqual2 = _interopRequireDefault(_isEqual);

var _constants = __webpack_require__("jsux");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = _constants2.default.NAME;


var getAllTables = function getAllTables(state) {
	return state[NAME];
};
var getQuestionTable = function getQuestionTable(_ref) {
	var state = _ref.state,
	    questionId = _ref.questionId;

	var tables = getAllTables(state);
	return tables[questionId];
};

var getTableForQuestion = exports.getTableForQuestion = (0, _reselect.createSelector)([getQuestionTable], function (table) {
	//console.log('getTableForQuestion: ', table);
	return table;
});

var makeGetTableForQuestion = exports.makeGetTableForQuestion = function makeGetTableForQuestion() {
	return getTableForQuestion;
};

var getQuestionTableFilters = exports.getQuestionTableFilters = (0, _reselect.createSelector)([getTableForQuestion], function (table) {
	if (table) {
		return table.filters;
	}

	return [];
});

/***/ }),

/***/ "PNNb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Button = __webpack_require__("Cpum");

var _Button2 = _interopRequireDefault(_Button);

var _lodash = __webpack_require__("B1iE");

var _styles = __webpack_require__("Q56b");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement('hr', null);

var RangeFilter = function (_Component) {
	_inherits(RangeFilter, _Component);

	function RangeFilter(props) {
		_classCallCheck(this, RangeFilter);

		var _this = _possibleConstructorReturn(this, (RangeFilter.__proto__ || Object.getPrototypeOf(RangeFilter)).call(this, props));

		_this.name = 'RangeFilter';

		var _this$props$filterDat = _this.props.filterData,
		    title = _this$props$filterDat.title,
		    _this$props$filterDat2 = _this$props$filterDat.from,
		    from = _this$props$filterDat2 === undefined ? 0 : _this$props$filterDat2,
		    _this$props$filterDat3 = _this$props$filterDat.to,
		    to = _this$props$filterDat3 === undefined ? 0 : _this$props$filterDat3,
		    _this$props$filterDat4 = _this$props$filterDat.min,
		    min = _this$props$filterDat4 === undefined ? 0 : _this$props$filterDat4,
		    _this$props$filterDat5 = _this$props$filterDat.max,
		    max = _this$props$filterDat5 === undefined ? 0 : _this$props$filterDat5,
		    applyStr = _this$props$filterDat.applyStr,
		    cancelStr = _this$props$filterDat.cancelStr,
		    clearStr = _this$props$filterDat.clearStr,
		    fromStr = _this$props$filterDat.fromStr,
		    toStr = _this$props$filterDat.toStr;


		_this.closeFilter = _this.closeFilter.bind(_this);
		_this.onFilterApply = _this.onFilterApply.bind(_this);
		_this.getMainBlock = _this.getMainBlock.bind(_this);
		_this.getButtonsBlock = _this.getButtonsBlock.bind(_this);
		_this.clearValues = _this.clearValues.bind(_this);
		_this.onValueChange = _this.onValueChange.bind(_this);

		_this.canApply = _this.canApply.bind(_this);

		_this.state = {
			title: title,
			from: from,
			to: to,
			min: min,
			max: max,
			applyStr: applyStr,
			cancelStr: cancelStr,
			clearStr: clearStr,
			fromStr: fromStr,
			toStr: toStr
		};
		return _this;
	}

	_createClass(RangeFilter, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.fromInput.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			//console.log(this.state, this.canApply());
			return _react2.default.createElement(
				'div',
				{ styleName: 'range-filter' },
				_react2.default.createElement(
					'div',
					{ styleName: 'title' },
					_react2.default.createElement(
						'span',
						null,
						this.state.title || 'Range filter'
					),
					_react2.default.createElement(_Button2.default, { styleName: 'clear-button', onClick: this.clearValues,
						buttonStyle: _Button2.default.BUTTON_STYLE.CENTERED_CONTENT, text: this.state.clearStr || "CLEAR", small: true })
				),
				this.getMainBlock(),
				_ref,
				this.getButtonsBlock()
			);
		}
	}, {
		key: 'closeFilter',
		value: function closeFilter() {
			this.props.closeFilter();
		}
	}, {
		key: 'clearValues',
		value: function clearValues(evt) {
			this.setState({
				from: this.state.min,
				to: this.state.max
			});
		}
	}, {
		key: 'onValueChange',
		value: function onValueChange(evt) {
			var _evt$target = evt.target,
			    name = _evt$target.name,
			    value = _evt$target.value;

			if (parseFloat(value) < 0) {
				return false;
			}
			var _state = this.state,
			    min = _state.min,
			    max = _state.max;

			this.setState(_defineProperty({}, name, parseFloat(value)));
		}
	}, {
		key: 'canApply',
		value: function canApply() {
			var _state2 = this.state,
			    from = _state2.from,
			    to = _state2.to,
			    min = _state2.min,
			    max = _state2.max;


			if (from < min || to > max || from > to) {
				return false;
			}

			if (isNaN(from) || isNaN(to)) {
				return false;
			}

			return true;
		}
	}, {
		key: 'getMainBlock',
		value: function getMainBlock() {
			var _this2 = this;

			return _react2.default.createElement(
				'div',
				{ styleName: 'main-block' },
				_react2.default.createElement(
					'div',
					{ styleName: 'content' },
					_react2.default.createElement(
						'div',
						{ styleName: 'from-block' },
						_react2.default.createElement(
							'span',
							null,
							this.state.fromStr || 'From'
						),
						_react2.default.createElement('input', { ref: function ref(element) {
								_this2.fromInput = element;
							}, type: 'number', name: 'from', value: this.state.from, onChange: this.onValueChange })
					),
					_react2.default.createElement(
						'div',
						{ styleName: 'to-block' },
						_react2.default.createElement(
							'span',
							null,
							this.state.toStr || 'To'
						),
						_react2.default.createElement('input', { ref: function ref(element) {
								_this2.toInput = element;
							}, type: 'number', name: 'to', value: this.state.to, onChange: this.onValueChange })
					)
				)
			);
		}
	}, {
		key: 'getButtonsBlock',
		value: function getButtonsBlock() {
			var canApply = this.canApply();
			return _react2.default.createElement(
				'div',
				{ styleName: 'buttons-block' },
				_react2.default.createElement(_Button2.default, {
					styleName: 'btnCancel',
					onClick: this.closeFilter,
					buttonStyle: _Button2.default.BUTTON_STYLE.CENTERED_CONTENT,
					text: this.state.cancelStr || "Cancel",
					small: true
				}),
				_react2.default.createElement(_Button2.default, {
					styleName: 'btnApply',
					onClick: this.onFilterApply,
					buttonStyle: _Button2.default.BUTTON_STYLE.RECTANGLE,
					text: this.state.applyStr || "Apply",
					small: true,
					primary: true,
					disabled: !canApply
				})
			);
		}
	}, {
		key: 'onFilterApply',
		value: function onFilterApply(evt) {
			var _state3 = this.state,
			    from = _state3.from,
			    to = _state3.to;


			this.props.applyFilter({
				items: {
					from: from,
					to: to
				}
			});
		}
	}]);

	return RangeFilter;
}(_react.Component);

exports.default = (0, _reactCssModules2.default)(RangeFilter, _extends({}, _styles2.default), { allowMultiple: true });

/***/ }),

/***/ "Q+ez":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Loader_component = __webpack_require__("pw5+");

var _Loader_component2 = _interopRequireDefault(_Loader_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Loader: _Loader_component2.default
};

/***/ }),

/***/ "Q56b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"range-filter":"styles__range-filter___3_ef2","title":"styles__title___2hDRr","clear-button":"styles__clear-button___22Ixm","main-block":"styles__main-block___1AFfY","content":"styles__content___293Cn","from-block":"styles__from-block___3f5IN","to-block":"styles__to-block___2G2ZF","buttons-block":"styles__buttons-block___1iOZ0","btnCancel":"styles__btnCancel___3wuHt","btnApply":"styles__btnApply___BLFjB"};

/***/ }),

/***/ "QJGd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MultipleChoice_component = __webpack_require__("M7Uv");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MultipleChoice_component).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "QZZK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"qualTblScrollCnt":"styles__qualTblScrollCnt___3v9gi","view-more-btn":"styles__view-more-btn___3iwVG","QualTableBody":"styles__QualTableBody___1t7f3","row":"styles__row___1rKe_","cell":"styles__cell___8wjOh","timestamp":"styles__timestamp___3YFvx","panelists":"styles__panelists___lyOYn","media":"styles__media___jmQ_M","comment":"styles__comment___2jSm4","likes":"styles__likes___v2v-h","tags":"styles__tags___3GGK9","sentiments":"styles__sentiments___1fRNL","odd":"styles__odd___1RyMy","even":"styles__even___2PW-9","content":"styles__content___293bl"};

/***/ }),

/***/ "S7So":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NAME = undefined;

var _selectors = __webpack_require__("Oe4J");

Object.keys(_selectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _selectors[key];
    }
  });
});

var _tables = __webpack_require__("4hlX");

Object.keys(_tables).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tables[key];
    }
  });
});

var _filters = __webpack_require__("5dsp");

Object.keys(_filters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _filters[key];
    }
  });
});

var _utils = __webpack_require__("Umgw");

var _constants = __webpack_require__("jsux");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = _constants2.default.initialState;
var NAME = exports.NAME = _constants2.default.NAME;

/*** REDUCER ***/
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  return (0, _utils.getSubReducer)(state, action);
};
/*** REDUCER END ***/

/***/ }),

/***/ "SJ9I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _shouldUpdate = __webpack_require__("e0pw");

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _TimeCell_component = __webpack_require__("6lnl");

var _TimeCell_component2 = _interopRequireDefault(_TimeCell_component);

var _TagsCell_component = __webpack_require__("5am/");

var _TagsCell_component2 = _interopRequireDefault(_TagsCell_component);

var _classnames3 = __webpack_require__("9qb7");

var _classnames4 = _interopRequireDefault(_classnames3);

var _styles = __webpack_require__("QZZK");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TableBody = function TableBody(props) {
  var rows = props.rows,
      cols = props.cols,
      questionId = props.questionId,
      hasMoreData = props.hasMoreData,
      viewMoreStr = props.viewMoreStr,
      getData = props.getData;

  var datacnt = "data_" + questionId;
  return _react2.default.createElement(
    "div",
    { styleName: "qualTblScrollCnt", id: datacnt },
    _react2.default.createElement(
      "table",
      { styleName: "QualTableBody" },
      buildTableBody(rows, cols)
    ),
    getViewMoreButton(hasMoreData, viewMoreStr, getData)
  );
};

var openGallery = function openGallery(modalId, mediaType) {
  TA.QuestionLayout.openGallery(modalId, mediaType); // eslint-disable-line
};

var _ref = _react2.default.createElement("div", null);

var getViewMoreButton = function getViewMoreButton(hasMoreData, viewMoreStr, getData) {
  if (hasMoreData === true) {
    return _react2.default.createElement(
      "div",
      {
        id: "linkToolbar",
        name: "linkToolbar",
        styleName: "view-more-btn",
        className: "viewTypeToolbar f_left visibleLinks"
      },
      _react2.default.createElement(
        "a",
        { onClick: getData },
        viewMoreStr
      )
    );
  }
  return _ref;
};

var _ref2 = _react2.default.createElement("i", {
  "data-remodal-action": "close",
  className: "fa fa-circle modal-close"
});

var _ref3 = _react2.default.createElement("i", {
  "data-remodal-action": "close",
  className: "fa fa-times modal-close"
});

var _ref4 = _react2.default.createElement("i", {
  "data-remodal-action": "close",
  className: "fa fa-circle modal-close"
});

var _ref5 = _react2.default.createElement("i", {
  "data-remodal-action": "close",
  className: "fa fa-times modal-close"
});

var buildTableBody = function buildTableBody(rows, cols) {
  return _react2.default.createElement(
    "tbody",
    null,
    rows.map(function (item, idx) {
      var cells = cols.map(function (colData, index) {
        var _classnames, _classnames2;

        //var cmplxClasses = cellClasses + ' ' + colData.key;
        var cellClasses = (0, _classnames4.default)((_classnames = {}, _defineProperty(_classnames, _styles2.default.cell, true), _defineProperty(_classnames, _styles2.default.odd, idx % 2 === 0), _defineProperty(_classnames, _styles2.default.even, idx % 2 !== 0), _defineProperty(_classnames, _styles2.default[colData.key], true), _classnames));
        var cellDivClasses = (0, _classnames4.default)((_classnames2 = {}, _defineProperty(_classnames2, _styles2.default.content, true), _defineProperty(_classnames2, _styles2.default[colData.key], true), _classnames2));
        var cellContent = void 0;
        if (colData.key == "timestamp") {
          cellContent = _react2.default.createElement(_TimeCell_component2.default, { timestamp: item[colData.key] });
          //cellContent = item[colData.key].date + " " + item[colData.key].time;
        } else if (colData.key == "tags") {
          //cellContent = item[colData.key].mainTag + " (+" + item[colData.key].tagsNum + ")";
          cellContent = _react2.default.createElement(_TagsCell_component2.default, { tags: item[colData.key] });
        } else if (colData.key == "media") {
          cellContent = item[colData.key].map(function (media) {
            var modalId = new Date().getTime() + "" + idx + "" + index;
            if (media.type == "IMAGE") {
              return _react2.default.createElement(
                "span",
                { key: media.name },
                _react2.default.createElement(
                  "a",
                  {
                    onClick: openGallery.bind(this, modalId),
                    href: "javascript:void(0)"
                  },
                  media.name
                ),
                _react2.default.createElement(
                  "div",
                  {
                    className: "remodal image-gallery-image-full-qual",
                    "data-remodal-id": modalId
                  },
                  _ref2,
                  _ref3,
                  _react2.default.createElement("img", { src: media.url })
                )
              );
            } else {
              return _react2.default.createElement(
                "span",
                { key: media.name },
                _react2.default.createElement(
                  "a",
                  {
                    onClick: function onClick() {
                      openGallery(modalId, media.type);
                    },
                    href: "javascript:void(0)"
                  },
                  media.name
                ),
                _react2.default.createElement(
                  "div",
                  {
                    className: "remodal image-gallery-image-full-qual",
                    "data-remodal-id": modalId,
                    "data-remodal-video-qual": "true",
                    "data-video-url": media.url
                  },
                  _ref4,
                  _ref5,
                  _react2.default.createElement(
                    "div",
                    { id: modalId },
                    _react2.default.createElement("iframe", {
                      className: "mediaPlayerFrame",
                      src: media.url
                    })
                  )
                )
              );
            }
          });
        } else if (colData.key == "likes" && parseInt(item[colData.key]) == 0) {
          cellContent = "";
        } else if (colData.key == "sentiment" && item[colData.key] == "none") {
          cellContent = "";
        } else {
          var txt = item[colData.key] + "";
          var regex = /(<([^>]+)>)/gi;
          var result = txt.replace(regex, " ");
          cellContent = result;
        }
        //console.log('Cell id: ', colData.key);

        return _react2.default.createElement(
          "td",
          { className: cellClasses, key: colData.key },
          _react2.default.createElement(
            "div",
            { className: cellDivClasses },
            cellContent
          )
        );
      });

      //console.log('RowKey: ', item.rowId);

      return _react2.default.createElement(
        "tr",
        { styleName: "row", key: item.rowId },
        cells
      );
    })
  );
};

var propsCheck = function propsCheck(props, nextProps) {
  var rows = props.rows,
      cols = props.cols,
      hasMoreData = props.hasMoreData;


  return JSON.stringify(rows) !== JSON.stringify(nextProps.rows) || JSON.stringify(cols) !== JSON.stringify(nextProps.cols) || hasMoreData !== nextProps.hasMoreData;
};

exports.default = (0, _shouldUpdate2.default)(propsCheck)((0, _reactCssModules2.default)(TableBody, _styles2.default));

/***/ }),

/***/ "SxRD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactCustomScrollbars = __webpack_require__("E5f5");

var _stringformat = __webpack_require__("cf+r");

var _stringformat2 = _interopRequireDefault(_stringformat);

var _Checkbox = __webpack_require__("+MyX");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _styles = __webpack_require__("NaHU");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxesPanel = function CheckboxesPanel(_ref) {
	var options = _ref.options,
	    isSelectAll = _ref.isSelectAll,
	    selectAllText = _ref.selectAllText,
	    totalFilterItemCount = _ref.totalFilterItemCount,
	    clearStr = _ref.clearStr,
	    filterSelectionCountStr = _ref.filterSelectionCountStr,
	    filterAllSelectionCountStr = _ref.filterAllSelectionCountStr,
	    selectAllCountStr = _ref.selectAllCountStr,
	    noOptionsStr = _ref.noOptionsStr,
	    onItemValueChange = _ref.onItemValueChange,
	    onToggleSelectAll = _ref.onToggleSelectAll,
	    onToggleAllVisibleValues = _ref.onToggleAllVisibleValues;


	//console.log(clearStr, totalFilterItemCount, filterSelectionCountStr, filterAllSelectionCountStr, selectAllCountStr);

	var selectedItemsCount = options.filter(function (option) {
		return option.selected === true;
	}).length;

	//console.log(selectedItemsCount, options.length, 'partial: ', selectedItemsCount > 0 && selectedItemsCount < options.length);

	return _react2.default.createElement(
		'div',
		{ styleName: 'checkboxes-panel-wrapper' },
		_react2.default.createElement(
			'div',
			{ styleName: 'choice-item-select-all', className: 'choice-item' },
			_react2.default.createElement(_Checkbox2.default, {
				disabled: options.length === 0,
				value: selectedItemsCount === options.length,
				checked: selectedItemsCount > 0 && selectedItemsCount <= options.length,
				partial: selectedItemsCount > 0 && selectedItemsCount < options.length,
				onChange: onToggleAllVisibleValues,
				small: true,
				label: selectAllText })
		),
		getHelperSelectionBlock({
			options: options,
			selectedItemsCount: selectedItemsCount,
			totalFilterItemCount: totalFilterItemCount,
			filterSelectionCountStr: filterSelectionCountStr,
			selectAllCountStr: selectAllCountStr,
			filterAllSelectionCountStr: filterAllSelectionCountStr,
			clearStr: clearStr,
			noOptionsStr: noOptionsStr,
			onToggleSelectAll: onToggleSelectAll,
			isSelectAll: isSelectAll
		}),
		_react2.default.createElement(
			_reactCustomScrollbars.Scrollbars,
			{ autoHeight: true },
			_react2.default.createElement(
				'div',
				{ styleName: 'choices-wrapper', className: 'choices-wrapper' },
				buildOptionsList({ options: options, onItemValueChange: onItemValueChange })
			)
		)
	);
};

CheckboxesPanel.defaultProps = {
	options: [],
	isSelectAll: false,
	totalFilterItemCount: 0,
	clearStr: '',
	filterSelectionCountStr: '',
	filterAllSelectionCountStr: '',
	selectAllCountStr: '',
	onItemValueChange: function onItemValueChange() {},
	onToggleSelectAll: function onToggleSelectAll() {},
	onToggleAllVisibleValues: function onToggleAllVisibleValues() {}
};

exports.default = (0, _reactCssModules2.default)(CheckboxesPanel, _extends({}, _styles2.default), { allowMultiple: true });


var buildOptionsList = function buildOptionsList() {
	var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	    options = _ref2.options,
	    onItemValueChange = _ref2.onItemValueChange;

	return options.map(function (option, idx) {
		return _react2.default.createElement(
			'div',
			{ styleName: 'choice-item', className: 'choice-item', key: idx },
			_react2.default.createElement(_Checkbox2.default, {
				value: option.selected === true,
				checked: option.selected === true,
				onChange: function onChange(value) {
					return onItemValueChange(option);
				},
				small: true,
				label: option.name })
		);
	});
};

var getHelperSelectionBlock = function getHelperSelectionBlock(_ref3) {
	var options = _ref3.options,
	    selectedItemsCount = _ref3.selectedItemsCount,
	    totalFilterItemCount = _ref3.totalFilterItemCount,
	    filterSelectionCountStr = _ref3.filterSelectionCountStr,
	    filterAllSelectionCountStr = _ref3.filterAllSelectionCountStr,
	    selectAllCountStr = _ref3.selectAllCountStr,
	    clearStr = _ref3.clearStr,
	    noOptionsStr = _ref3.noOptionsStr,
	    onToggleSelectAll = _ref3.onToggleSelectAll,
	    isSelectAll = _ref3.isSelectAll;

	var selectedStringFormatted = (0, _stringformat2.default)(filterSelectionCountStr.replace('%s', '{0}'), selectedItemsCount);
	var selectAllStringFormatted = (0, _stringformat2.default)(selectAllCountStr.replace('%s', '{0}'), totalFilterItemCount);
	var allSelectedStringFormatted = (0, _stringformat2.default)(filterAllSelectionCountStr.replace('%s', '{0}'), totalFilterItemCount);

	var leftBlockText = isSelectAll || totalFilterItemCount === selectedItemsCount ? allSelectedStringFormatted : selectedStringFormatted,
	    rightBlockText = isSelectAll || totalFilterItemCount === selectedItemsCount ? clearStr : selectAllStringFormatted;

	//console.log(isSelectAll);

	if (options.length === 0) {
		return _react2.default.createElement(
			'div',
			{ styleName: 'helper-no-selection-block' },
			noOptionsStr
		);
	} else {

		return _react2.default.createElement(
			'div',
			{ styleName: 'helper-selection-block' },
			[_react2.default.createElement(
				'div',
				{ styleName: 'inner-block left-block', key: 1 },
				_react2.default.createElement(
					'span',
					null,
					leftBlockText
				)
			), _react2.default.createElement(
				'div',
				{ styleName: 'inner-block right-block', key: 2 },
				_react2.default.createElement(
					'span',
					{ onClick: onToggleSelectAll },
					rightBlockText
				)
			)]
		);
	}
};

/***/ }),

/***/ "UNHa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"styles__wrapper___U_vSC"};

/***/ }),

/***/ "Umgw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubReducer = undefined;

var _constants = __webpack_require__("jsux");

var _constants2 = _interopRequireDefault(_constants);

var _tables = __webpack_require__("4hlX");

var _tables2 = _interopRequireDefault(_tables);

var _filters = __webpack_require__("5dsp");

var _filters2 = _interopRequireDefault(_filters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTION_NAMES = _constants2.default.ACTION_NAMES;
var getSubReducer = exports.getSubReducer = function getSubReducer(state, action) {
  if (action.type.indexOf('QUAL_TABLE/FILTER/') === 0) {
    return (0, _filters2.default)(state, action);
  }

  if (action.type.indexOf('QUAL_TABLE/TABLE/') === 0) {
    return (0, _tables2.default)(state, action);
  }

  return state;
};

/***/ }),

/***/ "UuX/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LocalizedApp = exports.connectedApp = undefined;

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("jYI/");

var _Localized = __webpack_require__("zrqD");

var _Localized2 = _interopRequireDefault(_Localized);

var _configureStore = __webpack_require__("J9Od");

var _configureStore2 = _interopRequireDefault(_configureStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _configureStore2.default)();

var pureApp = function pureApp(props) {
	return _react2.default.createElement(
		_reactRedux.Provider,
		{ store: store },
		_react2.default.createElement('div', { id: 'ta-react-app', style: { 'overflowY': 'hidden' } })
	);
};

var mapStateToProps = function mapStateToProps(state) {
	return {
		report: state.report
	};
};

var connectedApp = exports.connectedApp = (0, _reactRedux.connect)(mapStateToProps, null)(function (props) {
	//console.log('App: ', props);
	return _react2.default.createElement(
		'div',
		{ id: 'ta-react-app' },
		_react2.default.createElement(props.intl.Message, { id: 'translation' }),
		_react2.default.createElement(props.intl.Message, { id: 'translationWithParams', args: ['LOL', 'LOL 2'] })
	);
});

var LocalizedApp = exports.LocalizedApp = (0, _Localized2.default)(pureApp);

exports.default = LocalizedApp;

/***/ }),

/***/ "WHDv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _TableHeader_component = __webpack_require__("hNfP");

var _TableHeader_component2 = _interopRequireDefault(_TableHeader_component);

var _TableBody_component = __webpack_require__("SJ9I");

var _TableBody_component2 = _interopRequireDefault(_TableBody_component);

var _LoadingLayerComponent = __webpack_require__("qJ+m");

var _LoadingLayerComponent2 = _interopRequireDefault(_LoadingLayerComponent);

var _CorruptTableLayer = __webpack_require__("eu4r");

var _CorruptTableLayer2 = _interopRequireDefault(_CorruptTableLayer);

var _styles = __webpack_require__("tQFm");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line

var _ref = _react2.default.createElement(
	'div',
	{ styleName: 'QualTable', className: 'grey analytics' },
	_react2.default.createElement(_CorruptTableLayer2.default, { show: true })
);

var TableComponent = function TableComponent(props) {
	//console.log(props.filters[0], "\n");
	if (!props.header) {
		return _ref;
	}

	return _react2.default.createElement(
		'div',
		{ styleName: 'QualTable', className: 'grey analytics' },
		_react2.default.createElement(_TableHeader_component2.default, _extends({}, props, {
			cols: props.header
		})),
		_react2.default.createElement(_TableBody_component2.default, _extends({}, props, {
			rows: props.data,
			cols: props.header,
			viewMoreStr: props.translations.viewMore
		})),
		_react2.default.createElement(_LoadingLayerComponent2.default, { loadingStr: props.translations.loadingStr, show: props.withLoadingLayer && props.loadingData })
	);
};

TableComponent.displayName = 'TableComponent';

exports.default = (0, _reactCssModules2.default)(TableComponent, _styles2.default);

/***/ }),

/***/ "c4e5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table-column-filter":"styles__table-column-filter___135Gl","multichoice-filter":"styles__multichoice-filter___2WzVQ","range-filter":"styles__range-filter___1rPf1","loading-wrapper":"styles__loading-wrapper___3rSnR"};

/***/ }),

/***/ "dCpF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Searchbox_component = __webpack_require__("1HbX");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Searchbox_component).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "eu4r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CorruptTableLayer = __webpack_require__("uH4K");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CorruptTableLayer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "fDSs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"multiple-choice-filter":"styles__multiple-choice-filter___1ACuG","title":"styles__title___1tCXG","load-more-block":"styles__load-more-block___3dOHl","btnLoadMore":"styles__btnLoadMore___3aNbA","loading-ph":"styles__loading-ph___11hZF","buttons-block":"styles__buttons-block___kehne","btnCancel":"styles__btnCancel___3C_C-","btnApply":"styles__btnApply___XW7-9"};

/***/ }),

/***/ "gjok":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _IntlProvider = __webpack_require__("BnZ4");

var _IntlProvider2 = _interopRequireDefault(_IntlProvider);

var _Localized = __webpack_require__("zrqD");

var _Localized2 = _interopRequireDefault(_Localized);

var _utils = __webpack_require__("4vXW");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (WrappedComponent) {
  var translationPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return function (_Component) {
    _inherits(WithTranslationsHOC, _Component);

    function WithTranslationsHOC(props) {
      _classCallCheck(this, WithTranslationsHOC);

      var _this = _possibleConstructorReturn(this, (WithTranslationsHOC.__proto__ || Object.getPrototypeOf(WithTranslationsHOC)).call(this, props));

      _this.translations = (0, _utils.getTranslations)(translationPath);
      return _this;
    }

    _createClass(WithTranslationsHOC, [{
      key: 'render',
      value: function render() {
        //let LocalizedComponent = Localized(WrappedComponent);

        //console.log(component);
        //console.log(localizedComponent);


        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { intl: { translations: this.translations } }));
      }
    }]);

    return WithTranslationsHOC;
  }(_react.Component);
};

/***/ }),

/***/ "hNfP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _find = __webpack_require__("y1nO");

var _find2 = _interopRequireDefault(_find);

var _shouldUpdate = __webpack_require__("e0pw");

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _TableHeaderCell_container = __webpack_require__("NRNw");

var _TableHeaderCell_container2 = _interopRequireDefault(_TableHeaderCell_container);

var _styles = __webpack_require__("Ggrw");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getColumns = function getColumns(props) {
		var filters = props.filters,
		    cols = props.cols,
		    getData = props.getData;


		return cols.map(function (colData, idx) {
				var filter = (0, _find2.default)(filters, { columnId: colData.key }) || null;

				return _react2.default.createElement(_TableHeaderCell_container2.default, _extends({}, props, {
						colData: colData,
						filter: filter,
						key: colData.key,
						onSortToggle: getData
				}));
		});
};

var TableHeader = function TableHeader(props) {
		return _react2.default.createElement(
				'table',
				{ styleName: 'QualTableHeader' },
				_react2.default.createElement(
						'tbody',
						null,
						_react2.default.createElement(
								'tr',
								{ styleName: 'row' },
								getColumns(props)
						)
				)
		);
};

TableHeader.displayName = 'TableHeaderComponent';

TableHeader.defaultProps = {
		cols: [],
		filters: [],
		sortDir: ''
};

var propsCheck = function propsCheck(props, nextProps) {
		var cols = props.cols,
		    filters = props.filters,
		    sortDir = props.sortDir;


		return JSON.stringify(cols) !== JSON.stringify(nextProps.cols) || JSON.stringify(filters) !== JSON.stringify(nextProps.filters) || JSON.stringify(sortDir) !== JSON.stringify(nextProps.sortDir);
};

exports.default = (0, _shouldUpdate2.default)(propsCheck)((0, _reactCssModules2.default)(TableHeader, _styles2.default));

/***/ }),

/***/ "jnYD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loader":"styles__loader___3GHPe","image":"styles__image___r3Xtr","text":"styles__text___1NXAH"};

/***/ }),

/***/ "jsux":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILTER_APPLY_ERROR = exports.FILTER_APPLY_SUCCESS = exports.FILTER_APPLY_START = exports.FILTER_APPLY = exports.FILTERS_HIDE_IN_ALL_TABLES = exports.FILTERS_UPDATE = exports.FILTER_TOGGLE_ERROR = exports.FILTER_TOGGLE_SUCCESS = exports.FILTER_TOGGLE_START = exports.FILTER_TOGGLE = exports.TABLE_SORT_CHANGE = exports.TABLE_UPDATE_SCALAR_PROPERTIES = exports.TABLE_DATA_LOAD_END = exports.TABLE_DATA_LOAD_ERROR = exports.TABLE_DATA_LOAD_SUCCESS = exports.TABLE_DATA_LOAD_START = exports.TABLE_DATA_LOAD = exports.TABLE_REMOVE = exports.TABLE_ADD = undefined;

var _utils = __webpack_require__("4vXW");

var NAME = 'QualTables';

var initialState = {};

var TABLE_TRANSLATIONS_KEY = 'QUAL_TABLE.translations';

var TABLE_ACTIONS_ENUM = {
  GET_COMMENTS: 'getComments',
  SORTING: 'sorting'
};

var SORT_DIRECTIONS_ENUM = {
  ASC: 'asc',
  DESC: 'desc',
  NONE: ''
};

var defaultTableState = {
  questionId: null,
  firstLoad: true,
  isReload: false,
  chunkSize: 10,
  data: [],
  filters: [],
  canShowFilters: true,
  header: [],
  loadingData: false,
  lastRowIndex: 1,
  hasMoreData: false,
  visibleFilterIdx: -1,
  action: TABLE_ACTIONS_ENUM.GET_COMMENTS,
  sortDir: SORT_DIRECTIONS_ENUM.NONE,
  translations: (0, _utils.getTranslations)(TABLE_TRANSLATIONS_KEY)
};

var TABLE_ADD = exports.TABLE_ADD = 'QUAL_TABLE/TABLE/ADD_TABLE';
var TABLE_REMOVE = exports.TABLE_REMOVE = 'QUAL_TABLE/TABLE/REMOVE_TABLE';
var TABLE_DATA_LOAD = exports.TABLE_DATA_LOAD = 'QUAL_TABLE/TABLE/TABLE_DATA_LOAD';
var TABLE_DATA_LOAD_START = exports.TABLE_DATA_LOAD_START = 'QUAL_TABLE/TABLE/TABLE_DATA_LOAD_START';
var TABLE_DATA_LOAD_SUCCESS = exports.TABLE_DATA_LOAD_SUCCESS = 'QUAL_TABLE/TABLE/TABLE_DATA_LOAD/SUCCESS';
var TABLE_DATA_LOAD_ERROR = exports.TABLE_DATA_LOAD_ERROR = 'QUAL_TABLE/TABLE/TABLE_DATA_LOAD/ERROR';
var TABLE_DATA_LOAD_END = exports.TABLE_DATA_LOAD_END = 'QUAL_TABLE/TABLE/TABLE_DATA_LOAD/END';
var TABLE_UPDATE_SCALAR_PROPERTIES = exports.TABLE_UPDATE_SCALAR_PROPERTIES = 'QUAL_TABLE/TABLE/TABLE_UPDATE_SCALAR_PROPERTIES';
var TABLE_SORT_CHANGE = exports.TABLE_SORT_CHANGE = 'QUAL_TABLE/TABLE/TABLE_SORT_CHANGE';

var FILTER_TOGGLE = exports.FILTER_TOGGLE = 'QUAL_TABLE/FILTER/FILTER_TOGGLE';
var FILTER_TOGGLE_START = exports.FILTER_TOGGLE_START = 'QUAL_TABLE/FILTER/FILTER_TOGGLE/START';
var FILTER_TOGGLE_SUCCESS = exports.FILTER_TOGGLE_SUCCESS = 'QUAL_TABLE/FILTER/FILTER_TOGGLE/SUCCESS';
var FILTER_TOGGLE_ERROR = exports.FILTER_TOGGLE_ERROR = 'QUAL_TABLE/FILTER/FILTER_TOGGLE/ERROR';
var FILTERS_UPDATE = exports.FILTERS_UPDATE = 'QUAL_TABLE/FILTER/FILTERS_UPDATE';
var FILTERS_HIDE_IN_ALL_TABLES = exports.FILTERS_HIDE_IN_ALL_TABLES = 'QUAL_TABLE/FILTER/FILTERS_HIDE_IN_ALL_TABLES';

var FILTER_APPLY = exports.FILTER_APPLY = 'QUAL_TABLE/FILTER/FILTER_APPLY';
var FILTER_APPLY_START = exports.FILTER_APPLY_START = 'QUAL_TABLE/FILTER/FILTER_APPLY/START';
var FILTER_APPLY_SUCCESS = exports.FILTER_APPLY_SUCCESS = 'QUAL_TABLE/FILTER/FILTER_APPLY/SUCCESS';
var FILTER_APPLY_ERROR = exports.FILTER_APPLY_ERROR = 'QUAL_TABLE/FILTER/FILTER_APPLY/ERROR';

exports.default = {
  NAME: NAME,
  initialState: initialState,
  TABLE_ACTIONS_ENUM: TABLE_ACTIONS_ENUM,
  SORT_DIRECTIONS_ENUM: SORT_DIRECTIONS_ENUM,
  defaultTableState: defaultTableState,
  ACTION_NAMES: {
    TABLE_ADD: TABLE_ADD,
    TABLE_REMOVE: TABLE_REMOVE,
    TABLE_DATA_LOAD: TABLE_DATA_LOAD,
    TABLE_DATA_LOAD_START: TABLE_DATA_LOAD_START,
    TABLE_DATA_LOAD_SUCCESS: TABLE_DATA_LOAD_SUCCESS,
    TABLE_DATA_LOAD_ERROR: TABLE_DATA_LOAD_ERROR,
    TABLE_DATA_LOAD_END: TABLE_DATA_LOAD_END,
    TABLE_UPDATE_SCALAR_PROPERTIES: TABLE_UPDATE_SCALAR_PROPERTIES,
    TABLE_SORT_CHANGE: TABLE_SORT_CHANGE,
    FILTER_TOGGLE: FILTER_TOGGLE,
    FILTER_TOGGLE_START: FILTER_TOGGLE_START,
    FILTER_TOGGLE_SUCCESS: FILTER_TOGGLE_SUCCESS,
    FILTER_TOGGLE_ERROR: FILTER_TOGGLE_ERROR,
    FILTER_APPLY: FILTER_APPLY,
    FILTER_APPLY_START: FILTER_APPLY_START,
    FILTER_APPLY_SUCCESS: FILTER_APPLY_SUCCESS,
    FILTER_APPLY_ERROR: FILTER_APPLY_ERROR,
    FILTERS_UPDATE: FILTERS_UPDATE,
    FILTERS_HIDE_IN_ALL_TABLES: FILTERS_HIDE_IN_ALL_TABLES
  }
};

/***/ }),

/***/ "lvnP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});
exports.clientObjectToServer = exports.serverObjectToClient = exports.setFilterLoadingValue = exports.setFilterVisibleValue = exports.hideAllFilters = exports.overwriteFilter = exports.getFilterByColumnId = exports.getFilterTypeByColumnId = exports.getFilterIndexByColumnId = exports.isFilterInArray = exports.isRangeFilterType = exports.isMultichoiceFilterType = exports.getFilterObject = exports.getRangeFilterObject = exports.getMultichoiceFilterOption = exports.getMultichoiceFilterObject = exports.getCommonFilterObject = exports.FILTER_TYPES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _filterTypesMap, _converters;

var _lodash = __webpack_require__("B1iE");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FILTER_TYPES = exports.FILTER_TYPES = {
		MULTICHOICE: 'multichoice',
		RANGE: 'range'
};

var filterTypesMap = (_filterTypesMap = {}, _defineProperty(_filterTypesMap, FILTER_TYPES.MULTICHOICE, ['panelists', 'tags', 'sentiments']), _defineProperty(_filterTypesMap, FILTER_TYPES.RANGE, ['likes']), _filterTypesMap);

var commonFilterObject = {
		title: null,
		columnId: null,
		error: false,
		visible: false,
		loading: false
};

var multichoiceFilterObject = _extends({}, commonFilterObject, {
		options: [],
		searchQuery: null,
		selectAllTitle: null,
		isAllSelected: false
});

var multichoiceFilterOption = {
		id: null,
		name: null,
		selected: false
};

var rangeFilterObject = _extends({}, commonFilterObject, {
		from: 0,
		to: 0,
		min: 0,
		max: 0
});

var getCommonFilterObject = exports.getCommonFilterObject = function getCommonFilterObject() {
		var columnId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return _extends({}, commonFilterObject, { columnId: columnId });
};

var getMultichoiceFilterObject = exports.getMultichoiceFilterObject = function getMultichoiceFilterObject() {
		var columnId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return _extends({}, multichoiceFilterObject, { columnId: columnId });
};

var getMultichoiceFilterOption = exports.getMultichoiceFilterOption = function getMultichoiceFilterOption(_ref) {
		var id = _ref.id,
		    name = _ref.name,
		    selected = _ref.selected;

		return _extends({}, multichoiceFilterOption, { id: id, name: name, selected: selected });
};

var getRangeFilterObject = exports.getRangeFilterObject = function getRangeFilterObject() {
		var columnId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return _extends({}, rangeFilterObject, { columnId: columnId });
};

var getFilterObject = exports.getFilterObject = function getFilterObject() {
		var columnId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		var filterType = getFilterTypeByColumnId(columnId);
		switch (filterType) {
				case FILTER_TYPES.MULTICHOICE:
						return getMultichoiceFilterObject(columnId);
				case FILTER_TYPES.RANGE:
						return getRangeFilterObject(columnId);
				default:
						return null;
		}
};

var isMultichoiceFilterType = exports.isMultichoiceFilterType = function isMultichoiceFilterType() {
		var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		return filterTypesMap['multichoice'].indexOf(name.toLowerCase()) > -1;
};

var isRangeFilterType = exports.isRangeFilterType = function isRangeFilterType() {
		var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		return filterTypesMap['range'].indexOf(name.toLowerCase()) > -1;
};

var isFilterInArray = exports.isFilterInArray = function isFilterInArray() {
		var columnId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

		return getFilterByColumnId(columnId, filters) !== null;
};

var getFilterIndexByColumnId = exports.getFilterIndexByColumnId = function getFilterIndexByColumnId(columnId, filters) {
		return _lodash2.default.findIndex(filters, { columnId: columnId });
};

var getFilterTypeByColumnId = exports.getFilterTypeByColumnId = function getFilterTypeByColumnId() {
		var columnId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		return Object.keys(filterTypesMap).filter(function (filterType) {
				return filterTypesMap[filterType].indexOf(columnId) > -1;
		})[0];
};

var getFilterByColumnId = exports.getFilterByColumnId = function getFilterByColumnId() {
		var columnId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

		//console.log('Searching filter: ', columnId, filters);
		return _lodash2.default.find(filters, { columnId: columnId }) || null;
};

var overwriteFilter = exports.overwriteFilter = function overwriteFilter(filter, filters) {
		var idx = getFilterIndexByColumnId(filter.columnId, filters);
		filters[idx] = _extends({}, filter);

		return filters;
};

var hideAllFilters = exports.hideAllFilters = function hideAllFilters(_ref2) {
		var filters = _ref2.filters;

		return [].concat(_toConsumableArray(filters)).map(function (filter) {
				var filterClone = _extends({}, filter);
				filterClone.visible = false;
				return filterClone;
		});
};

var setFilterVisibleValue = exports.setFilterVisibleValue = function setFilterVisibleValue(_ref3) {
		var filters = _ref3.filters,
		    columnId = _ref3.columnId,
		    value = _ref3.value;

		return [].concat(_toConsumableArray(filters)).map(function (filter) {
				var filterClone = _extends({}, filter);
				filterClone.visible = filter.columnId === columnId ? value : false;
				return filterClone;
		});
};

var setFilterLoadingValue = exports.setFilterLoadingValue = function setFilterLoadingValue(_ref4) {
		var filters = _ref4.filters,
		    columnId = _ref4.columnId,
		    value = _ref4.value;

		return [].concat(_toConsumableArray(filters)).map(function (filter) {
				var filterClone = _extends({}, filter);
				filterClone.loading = filter.columnId === columnId ? value : false;
				return filterClone;
		});
};

var serverObjectToClient = exports.serverObjectToClient = function serverObjectToClient(clientObject, serverObject) {
		var filterType = getFilterTypeByColumnId(clientObject.columnId);
		if (!filterType) {
				return clientObject;
		}
		return converters[getFilterTypeByColumnId(clientObject.columnId)].serverObjectToClient(clientObject, serverObject);
};

var clientObjectToServer = exports.clientObjectToServer = function clientObjectToServer(clientObject) {
		var serverObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		var filterType = getFilterTypeByColumnId(clientObject.columnId);
		if (!filterType) {
				return clientObject;
		}
		return converters[getFilterTypeByColumnId(clientObject.columnId)].clientObjectToServer(clientObject, serverObject);
};

var converters = (_converters = {}, _defineProperty(_converters, FILTER_TYPES.MULTICHOICE, {
		serverObjectToClient: function serverObjectToClient(clientObject, serverObject) {
				var selectAllTitle = serverObject.selectAllTitle,
				    title = serverObject.title,
				    filterItemList = serverObject.filterItemList,
				    isSelectAll = serverObject.isSelectAll,
				    totalFilterItemCount = serverObject.totalFilterItemCount,
				    clearStr = serverObject.clearStr,
				    noOptionsStr = serverObject.noOptionsStr,
				    loadMoreStr = serverObject.loadMoreStr,
				    applyStr = serverObject.applyStr,
				    cancelStr = serverObject.cancelStr,
				    searchPhStr = serverObject.searchPhStr,
				    filterSelectionCountStr = serverObject.filterSelectionCountStr,
				    filterAllSelectionCountStr = serverObject.filterAllSelectionCountStr,
				    selectAllCountStr = serverObject.selectAllCountStr,
				    hasMore = serverObject.hasMore,
				    searchQuery = serverObject.searchQuery;


				return _extends({}, clientObject, {
						selectAllTitle: selectAllTitle,
						title: title,
						options: filterItemList,
						isAllSelected: isSelectAll,
						totalFilterItemCount: totalFilterItemCount,
						clearStr: clearStr,
						loadMoreStr: loadMoreStr,
						applyStr: applyStr,
						cancelStr: cancelStr,
						noOptionsStr: noOptionsStr,
						searchPh: searchPhStr,
						filterSelectionCountStr: filterSelectionCountStr,
						filterAllSelectionCountStr: filterAllSelectionCountStr,
						selectAllCountStr: selectAllCountStr,
						hasMore: hasMore,
						searchQuery: searchQuery
				});
		},
		clientObjectToServer: function clientObjectToServer(clientObject, serverObject) {
				var filterItemList = [].concat(_toConsumableArray(clientObject.options));
				var valueIds = filterItemList.filter(function (item) {
						return item.selected === true;
				}).map(function (option) {
						return option.id;
				});
				return _extends({}, serverObject, {
						filterItemList: filterItemList,
						valueIds: valueIds
				});
		}
}), _defineProperty(_converters, FILTER_TYPES.RANGE, {
		serverObjectToClient: function serverObjectToClient(clientObject, serverObject) {
				var title = serverObject.title,
				    from = serverObject.from,
				    to = serverObject.to,
				    min = serverObject.min,
				    max = serverObject.max,
				    applyStr = serverObject.applyStr,
				    cancelStr = serverObject.cancelStr,
				    clearStr = serverObject.clearStr,
				    fromStr = serverObject.fromStr,
				    toStr = serverObject.toStr;


				return _extends({}, clientObject, {
						title: title,
						from: from,
						to: to,
						min: min,
						max: max,
						applyStr: applyStr,
						cancelStr: cancelStr,
						clearStr: clearStr,
						fromStr: fromStr,
						toStr: toStr
				});
		},
		clientObjectToServer: function clientObjectToServer(clientObject, serverObject) {
				var from = clientObject.from,
				    to = clientObject.to;


				return _extends({}, serverObject, {
						from: from,
						to: to
				});
		}
}), _converters);

/***/ }),

/***/ "m0E5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"styles__wrapper___2nOgK","content":"styles__content___1N2gD","icon":"styles__icon___23FTi","text":"styles__text___c8TPN"};

/***/ }),

/***/ "pw5+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _styles = __webpack_require__("jnYD");

var _styles2 = _interopRequireDefault(_styles);

__webpack_require__("MB5U");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement('div', { styleName: 'image' });

var Loader = function Loader(props) {
	return _react2.default.createElement(
		'div',
		{ styleName: 'loader' },
		_ref,
		_react2.default.createElement(
			'div',
			{ styleName: 'text' },
			props.text || 'Loading...'
		)
	);
};

exports.default = (0, _reactCssModules2.default)(Loader, _styles2.default);

/***/ }),

/***/ "qJ+m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _styles = __webpack_require__("m0E5");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line

var _ref2 = _react2.default.createElement('div', { styleName: 'icon' });

var LoadingLayerComponent = function LoadingLayerComponent(props) {
		var loadingStr = props.loadingStr,
		    show = props.show;

		var _ref = _react2.default.createElement(
				'div',
				{ styleName: 'wrapper' },
				_react2.default.createElement(
						'div',
						{ styleName: 'content' },
						_ref2,
						_react2.default.createElement(
								'div',
								{ styleName: 'text' },
								loadingStr
						)
				)
		);

		function getLayout() {
				if (show === true) {
						return _ref;
				} else {
						return null;
				}
		}

		return getLayout();
};

LoadingLayerComponent.defaultProps = {
		show: false,
		loadingStr: 'Loading...'
};

exports.default = (0, _reactCssModules2.default)(LoadingLayerComponent, _styles2.default);

/***/ }),

/***/ "swAs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withTranslations = __webpack_require__("gjok");

var _withTranslations2 = _interopRequireDefault(_withTranslations);

var _withStore = __webpack_require__("NddO");

var _withStore2 = _interopRequireDefault(_withStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  withTranslations: _withTranslations2.default,
  withStore: _withStore2.default
};

/***/ }),

/***/ "tQFm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"QualTable":"styles__QualTable___34YUE"};

/***/ }),

/***/ "tgbF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _redux = __webpack_require__("fpuT");

var _Table_component = __webpack_require__("WHDv");

var _Table_component2 = _interopRequireDefault(_Table_component);

var _Loader_component = __webpack_require__("pw5+");

var _Loader_component2 = _interopRequireDefault(_Loader_component);

var _styles = __webpack_require__("tQFm");

var _styles2 = _interopRequireDefault(_styles);

var _ThemeProvider = __webpack_require__("iZaX");

var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);

var _ducks = __webpack_require__("S7So");

var _reactRedux = __webpack_require__("jYI/");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line


var THEME_CONFIG = {
  lightColor: "#327e95"
};

var _ref5 = _react2.default.createElement(_Loader_component2.default, null);

var QualTableContainer = function (_PureComponent) {
  _inherits(QualTableContainer, _PureComponent);

  function QualTableContainer(props) {
    _classCallCheck(this, QualTableContainer);

    var _this = _possibleConstructorReturn(this, (QualTableContainer.__proto__ || Object.getPrototypeOf(QualTableContainer)).call(this, props));

    _this.displayName = "QualTableContainer";

    _this.loadData = _this.loadData.bind(_this);
    _this.getFilter = _this.getFilter.bind(_this);
    _this.toggleFilter = _this.toggleFilter.bind(_this);
    _this.searchInFilter = _this.searchInFilter.bind(_this);
    _this.applyFilter = _this.applyFilter.bind(_this);
    _this.loadMore = _this.loadMore.bind(_this);

    return _this;
  }

  /*shouldComponentUpdate(nextProps, nextState) {
   return true;
   }*/

  _createClass(QualTableContainer, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      //console.log('CWRP: ', this.props, nextProps);
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      //console.log('CWM: ', this.props);

      var _props = this.props,
          questionId = _props.questionId,
          addTable = _props.addTable;

      addTable({
        questionId: questionId
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      //console.log('CDM: ', this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.removeTable(this.props.questionId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      //console.log(prevProps.tableState, this.props.tableState);
      if (!prevProps.tableState && this.props.tableState && this.props.tableState.firstLoad && !this.props.tableState.isReload) {
        this.loadData(this.props.tableState.sortDir, false);
      } else if (prevProps.tableState && this.props.tableState && this.props.tableState.isReload) {}
    }
  }, {
    key: "loadData",
    value: function loadData(sortDir, isSort) {
      var tableState = this.props.tableState;
      var questionId = tableState.questionId;


      if (isSort === true) {
        this.props.changeTableSort({ questionId: questionId, sortDir: sortDir });
        return;
      }

      this.props.loadData({ questionId: questionId, isSort: isSort, sortDir: sortDir });
    }
  }, {
    key: "applyFilter",
    value: function applyFilter(params) {
      var filter = params.filter,
          isSelectAll = params.isSelectAll,
          selectAllChanged = params.selectAllChanged;
      var questionId = this.props.tableState.questionId;


      this.props.applyTableFilter(_extends({}, params, { questionId: questionId }));
    }
  }, {
    key: "toggleFilter",
    value: function toggleFilter(columnId) {
      var questionId = this.props.questionId;


      this.props.toggleFilter({ questionId: questionId, columnId: columnId });
      this.getFilter({ columnId: columnId });
    }
  }, {
    key: "getFilter",
    value: function getFilter(_ref) {
      var columnId = _ref.columnId,
          searchQuery = _ref.searchQuery,
          lastRowIndex = _ref.lastRowIndex;
      var questionId = this.props.questionId;


      var params = {
        questionId: questionId,
        columnId: columnId
      };

      if (searchQuery && searchQuery.length > 0) {
        params.searchQuery = searchQuery;
      }

      this.props.loadFilterData(params);
    }
  }, {
    key: "searchInFilter",
    value: function searchInFilter(params) {

      this.props.searchInFilter(_extends({}, params, { questionId: this.props.questionId }));
    }
  }, {
    key: "loadMore",
    value: function loadMore(_ref2) {
      var chunkSize = _ref2.chunkSize,
          lastFilterItemIndex = _ref2.lastFilterItemIndex,
          columnId = _ref2.columnId,
          isSelectAll = _ref2.isSelectAll,
          selectAllChanged = _ref2.selectAllChanged,
          searchQuery = _ref2.searchQuery;
      var questionId = this.props.questionId;


      this.props.loadMoreFilterData({
        questionId: questionId,
        chunkSize: chunkSize,
        lastFilterItemIndex: lastFilterItemIndex,
        columnId: columnId,
        isSelectAll: isSelectAll,
        selectAllChanged: selectAllChanged,
        searchQuery: searchQuery
      });
    }
  }, {
    key: "render",
    value: function render() {
      //console.log(this.props);

      var _ref3 = _extends({}, this.props.tableState || {}),
          loadingData = _ref3.loadingData,
          header = _ref3.header,
          data = _ref3.data,
          filters = _ref3.filters,
          hasMoreData = _ref3.hasMoreData,
          sortDir = _ref3.sortDir;

      var _ref4 = _extends({}, this.props.tableState || {}),
          questionId = _ref4.questionId,
          translations = _ref4.translations;

      //console.log(this.props.tableState, this.props.visibleFilter);

      return _react2.default.createElement(
        _ThemeProvider2.default,
        { config: THEME_CONFIG },
        this.props.tableState ? _react2.default.createElement(_Table_component2.default, {
          loadingData: loadingData,
          withLoadingLayer: true,
          header: header,
          data: data,
          filters: [].concat(_toConsumableArray(filters)),
          questionId: questionId,
          hasMoreData: hasMoreData,
          getData: this.loadData,
          getFilter: this.getFilter,
          toggleFilter: this.toggleFilter,
          searchInFilter: this.searchInFilter,
          applyFilter: this.applyFilter,
          loadMore: this.loadMore,
          translations: translations,
          sortDir: sortDir
        }) : _ref5
      );
    }
  }]);

  return QualTableContainer;
}(_react.PureComponent);

QualTableContainer.defaultProps = {
  /*chunkSize: 10*/
};

var mapStateToProps = function mapStateToProps(state, props) {
  var questionId = props.questionId;

  var tableState = (0, _ducks.getTableForQuestion)({ state: state, questionId: questionId });

  //console.log(questionId);

  return {
    tableState: tableState
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addTable: (0, _redux.bindActionCreators)(_ducks.addTable, dispatch),
    removeTable: (0, _redux.bindActionCreators)(_ducks.removeTable, dispatch),
    loadData: (0, _redux.bindActionCreators)(_ducks.loadData, dispatch),
    toggleFilter: (0, _redux.bindActionCreators)(_ducks.toggleFilter, dispatch),
    loadFilterData: (0, _redux.bindActionCreators)(_ducks.loadFilterData, dispatch),
    applyTableFilter: (0, _redux.bindActionCreators)(_ducks.applyFilter, dispatch),
    searchInFilter: (0, _redux.bindActionCreators)(_ducks.searchInFilter, dispatch),
    loadMoreFilterData: (0, _redux.bindActionCreators)(_ducks.loadMoreFilterData, dispatch),
    changeTableSort: (0, _redux.bindActionCreators)(_ducks.changeTableSort, dispatch)
  };
};

exports.default = (0, _reactCssModules2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QualTableContainer), _styles2.default);

/***/ }),

/***/ "uH4K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("CwoH");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssModules = __webpack_require__("irn1");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _styles = __webpack_require__("UNHa");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _react2.default.createElement(
  'div',
  { styleName: 'wrapper' },
  _react2.default.createElement(
    'h3',
    null,
    'Something went wrong.'
  ),
  _react2.default.createElement(
    'h3',
    null,
    'Failed to load table.'
  )
);

var CorruptTableLayer = function CorruptTableLayer(_ref) {
  var show = _ref.show;

  return show === true ? _ref2 : null;
};

CorruptTableLayer.defaultProps = {
  show: false
};

exports.default = (0, _reactCssModules2.default)(CorruptTableLayer, _styles2.default);

/***/ }),

/***/ "xbO0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RangeFilter_component = __webpack_require__("PNNb");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RangeFilter_component).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })

},["JkW7"]);


// WEBPACK FOOTER //
// app.min.js